import {Dimensions, Platform, StyleSheet} from "react-native";
import DeviceInfo from "../../importCalss/DeviceInfo";
//import {moderateScale} from "../../tools/Scaling";

global.IdCity = 0;
const {width: SCREEN_WIDTH, height: SCREEN_HEIGHT} = Dimensions.get("window");
//let BASE_URLS = "http://portal.arak.ir";
let URL_PWA_IMAGE = "https://app137.satia.co";
//*********** Fire *************//
let BASE_URLS_125 = "https://saina.satia.co/";

//FireChabahar
//let BASE_URLS_125 = "http://185.113.56.50";

//FireArdabil
//let BASE_URLS_125 = "http://185.113.56.50";

//FireDezfol
//let BASE_URLS_125 = "https://saina.satia.co";

//FireZarghan
//let BASE_URLS_125 = "https://saina.satia.co";

//let BASE_URL_SATIA : 'http://192.168.168.223:8000/';
// let BASE_URL_SATIA= 'http://192.168.168.223:8000/';
// let BASE_URL_SATIA = 'https://app137.satia.co/';
//  let BASE_URL_SATIA_IMAGE= 'http://192.168.168.223:3000/';
let BASE_URL_SATIA_IMAGE = 'https://app.satia.co/';
// let BASE_URL_SATIA_IMAGE = 'https://app137.satia.co/';
// let BASE_URL_SATIA_IMAGE= 'https://app.satia.co/';
//let URL_PWA = 'https://app.satia.co/';

//SatiaOperator
//let URL_PWA = 'https://task.satia.co/';
// let BASE_URL_SATIA= 'https://task.satia.co/proxy.php/';
// let BASE_URL_SATIA_IMAGE= 'https://task.satia.co/';

//Ahvaz
//let BASE_URL_SATIA_IMAGE = 'https://app137.ahvaz.ir/';

let BASE_URL_SATIA = 'https://app.satia.co/proxy.php/';
//let BASE_URL_SATIA = 'http://185.113.56.1:8003/';
//let BASE_URL_SATIA : 'http://192.168.168.241:8003/';

//*********** 137 *************//
//let BASE_URLS = "https://app137.satia.co/proxy.php/";
//let BASE_URLS = "http://185.113.56.50";
//let URL_PWA = "https://app137.satia.co";
// let BASE_URL = Platform.OS === "web" ? URL_PWA : "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/demo/proxy.php" : BASE_URL;
//let BASE_URLS = "http://185.113.56.50";
//let BASE_URLS = "http://portal.arak.ir";

//let BASE_URLS = "http://185.113.56.52";

//Arak
//let URL_PWA_IMAGE = "https://my.arak.ir";
//let URL_PWA =  "https://my.arak.ir" ;
// let BASE_URL = Platform.OS === "web" ? URL_PWA : "http://portal.arak.ir";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/arak/137/proxy.php" : BASE_URL;

//Golpayegan
//let BASE_URLS = "http://137.golpayegancity.ir:8084";


//Rafsanjan
//let BASE_URLS = "http://137.rafsanjan.ir";

//Marvdasht
// let URL_PWA =  "https://app137.marvdasht.ir" ;
// let URL_PWA =  "https://app137.satia.co" ;
// URL_PWA_IMAGE =  "https://app137.marvdasht.ir" ;

// let BASE_URL = Platform.OS === "web" ? URL_PWA: "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/marvdasht/proxy.php" : BASE_URL;


//Kerman
//let BASE_URLS = "https://137.kerman.ir";
// let BASE_URL = Platform.OS === "web" ? "https://app137.satia.co" : "https://137.kerman.ir";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/kerman/proxy.php" : BASE_URL;
//sharban
//let BASE_URLS = "http://185.113.56.50";

//Ilam
// let URL_PWA =  "https://app137.ilam.com" ;
// let URL_PWA =  "https://app137.satia.co" ;
// URL_PWA_IMAGE =  "https://app137.ilam.com" ;
// let BASE_URL = Platform.OS === "web" ? URL_PWA: "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/ilam/proxy.php" : BASE_URL;
// let BASE_URL = "https://saina.satia.co/";
// let BASE_URLS = BASE_URL;


//Jahrom
//let BASE_URLS = "http://185.113.56.50";
//Ahvaz
//let URL_PWA =  "https://app137.satia.co" ;
// URL_PWA_IMAGE =  "https://app137.ahvaz.ir" ;
// let BASE_URL = Platform.OS==="web"?URL_PWA:"http://185.113.56.50";
// let BASE_URL = Platform.OS==="web"?URL_PWA:"http://185.113.56.50";
// let BASE_URLS = Platform.OS==="web"?BASE_URL+"/proxy.php":BASE_URL;

//MahmoodAbad
// let URL_PWA =  "https://app137.mahmoodabad.ir" ;
// let URL_PWA =  "https://app137.satia.co" ;
// URL_PWA_IMAGE =  "https://app137.mahmoodabad.ir" ;

//let BASE_URL = Platform.OS==="web"?"https://app137.satia.co":"http://185.113.56.50";
//let BASE_URLS = Platform.OS==="web"?BASE_URL+"/proxy/mahmoodabad/proxy.php":BASE_URL;


//MahalemaArak
// let URL_PWA_IMAGE = "https://my.arak.ir";
// let URL_PWA =  "https://my.arak.ir" ;
// let BASE_URL = Platform.OS === "web" ? URL_PWA : "http://portal.arak.ir";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/arak/mahalema/proxy.php" : BASE_URL;
// let BASE_URL = Platform.OS==="web"?"https://my.arak.ir":"http://185.113.56.50";
// let BASE_URLS = Platform.OS==="web"?BASE_URL+"/proxy/arak/mahalema/proxy.php":BASE_URL;


//Borazjan
// let URL_PWA =  "https://app137.borazjan.ir" ;
// let URL_PWA =  "https://app137.satia.co" ;
// URL_PWA_IMAGE =  "https://app137.borazjan.ir" ;
// let BASE_URL = Platform.OS === "web" ? URL_PWA: "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/borazjan/proxy.php" : BASE_URL;


//Roudan
// let URL_PWA =  "https://app137.roudancity.ir" ;
// let URL_PWA =  "https://app137.satia.co" ;
// URL_PWA_IMAGE =  "https://app137.roudancity.ir" ;

// let BASE_URL = Platform.OS === "web" ? URL_PWA: "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/borazjan/proxy.php" : BASE_URL;

//Maraghe
// let URL_PWA =  "https://app137.maraghe.com" ;
// let URL_PWA =  "https://app137.satia.co" ;
// URL_PWA_IMAGE =  "https://app137.maraghe.com" ;

// let BASE_URL = Platform.OS === "web" ? URL_PWA: "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/maraghe/proxy.php" : BASE_URL;

// let BASE_URL = "https://saina.satia.co/";
// let BASE_URLS = BASE_URL;

//Khorramshahr
// let URL_PWA =  "https://app137.khorramshahr.ir" ;
// let URL_PWA =  "https://app137.satia.co" ;
// URL_PWA_IMAGE =  "https://app137.khorramshahr.ir" ;

// let BASE_URL = Platform.OS === "web" ? URL_PWA: "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/khorramshahr/proxy.php" : BASE_URL;

//Bushehr
// let URL_PWA =  "https://app137.bushehr.ir" ;
// let URL_PWA =  "https://app137.satia.co" ;
// URL_PWA_IMAGE =  "https://app137.bushehr.ir" ;

// let BASE_URL = Platform.OS === "web" ? URL_PWA: "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/bushehr/proxy.php" : BASE_URL;


//Gerash
// let URL_PWA =  "https://app137.gerash.ir" ;
// let URL_PWA =  "https://app137.satia.co" ;
// URL_PWA_IMAGE =  "https://app137.gerash.ir" ;

// let BASE_URL = Platform.OS === "web" ? URL_PWA: "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/gerash/proxy.php" : BASE_URL;

//Behbahan
// let URL_PWA =  "https://app137.behbahan.ir" ;
// let URL_PWA =  "https://app137.satia.co" ;
// URL_PWA_IMAGE =  "https://app137.behbahan.ir" ;

// let BASE_URL = Platform.OS === "web" ? URL_PWA: "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/behbahan/proxy.php" : BASE_URL;

//Boumehen
// let URL_PWA =  "https://app137.sh-boumehen.ir" ;
// let URL_PWA =  "https://app137.satia.co" ;
// URL_PWA_IMAGE =  "https://app137.sh-boumehen.ir" ;

// let BASE_URL = Platform.OS === "web" ? URL_PWA: "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/behbahan/proxy.php" : BASE_URL;

//Zarghan
// let URL_PWA =  "https://app137.zarghan.ir" ;
// let URL_PWA =  "https://app137.satia.co" ;
// URL_PWA_IMAGE =  "https://app137.zarghan.ir" ;

// let BASE_URL = Platform.OS === "web" ? URL_PWA: "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/behbahan/proxy.php" : BASE_URL;

//Abadeh
// let URL_PWA =  "https://app137.sh-abadeh.ir" ;
// let URL_PWA =  "https://app137.satia.co" ;
// URL_PWA_IMAGE =  "https://app137.sh-abadeh.ir" ;

// let BASE_URL = Platform.OS === "web" ? URL_PWA: "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/abadeh/proxy.php" : BASE_URL;


//Lavasan
// let URL_PWA =  "https://app137.lavasan.ir" ;
// let URL_PWA =  "https://app137.satia.co" ;
// URL_PWA_IMAGE =  "https://app137.lavasan.ir" ;

// let BASE_URL = Platform.OS === "web" ? URL_PWA: "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/behbahan/proxy.php" : BASE_URL;

//Cloud
let URL_PWA =  "https://pwa137.satia.co" ;
// let URL_PWA =  "https://app137.satia.co" ;
URL_PWA_IMAGE =  "https://pwa137.satia.co" ;

// let BASE_URL = Platform.OS === "web" ? URL_PWA: "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/cloud/proxy.php" : BASE_URL;

//Shahrman
// let URL_PWA =  "https://app137.satia.co" ;
// let URL_PWA = "https://app137.satia.co";
// URL_PWA_IMAGE = "https://app137.satia.co";

// let BASE_URL = Platform.OS === "web" ? URL_PWA: "http://185.113.56.50";
// let BASE_URLS = Platform.OS === "web" ? BASE_URL + "/proxy/shahrman/proxy.php" : BASE_URL;

let BASE_URL = "https://saina.satia.co/";
let BASE_URLS = BASE_URL;


let BASE_URL_SN = BASE_URLS + "/modules/CustomerPortal/api.php";

//Arak
//let baseUrlWP_OR = "http://app.arak.ir";
// let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/arak/137/proxyapp.php" : "http://app.arak.ir";


//Golpayegan
//let baseUrlWP_OR ="http://app.golpayegancity.ir";


//Rafsanjan
//let baseUrlWP_OR ="http://app.rafsanjan.ir";

//Police
//let baseUrlWP_OR ="http://app.satiaisp.com";
//let baseUrlWP_OR ="https://app137.satia.co/proxyapp.php";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/demo/proxyapp.php" : "http://app.satiaisp.com";
//let baseUrlWP_OR = Platform.OS === "web" ? URL_PWA + "/proxy/demo/proxyapp.php" : "http://app.satiaisp.com";

//let baseUrlWP_OR =Platform.OS==="web"?BASE_URL+"/proxyapp.php":"http://app.satiaisp.com";

//Marvdasht
//let baseUrlWP_OR = Platform.OS === "web" ? URL_PWA + "/proxy/marvdasht/proxyapp.php" : "http://app.marvdasht.ir";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/marvdasht/proxyapp.php" : "http://app.marvdasht.ir";
//let baseUrlWP_OR = "http://app.marvdasht.ir/";
//Kerman
//let baseUrlWP_OR ="http://kerman.iran137.com";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/kerman/proxyapp.php" : "http://kerman.iran137.com";

//Ahvaz
//let baseUrlWP_OR ="http://ahvaz.iran137.com";
//let baseUrlWP_OR =Platform.OS==="web"?BASE_URL+"/proxyapp.php":"http://ahvaz.iran137.com";
//let baseUrlWP_OR =Platform.OS==="web"?BASE_URL+"/proxyapp.php":"http://ahvaz.iran137.com";

//MahmoodAbad
//let baseUrlWP_OR ="http://ahvaz.iran137.com";
//let baseUrlWP_OR =Platform.OS==="web"?BASE_URL+"/proxy/mahmoodabad/proxyapp.php":"http://app.mahmoodabad.ir/";

//Ilam
//let baseUrlWP_OR ="https://app.ilam.ir";
//let baseUrlWP_OR = Platform.OS === "web" ? URL_PWA + "/proxy/ilam/proxyapp.php" : "http://app.ilam.ir";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/ilam/proxyapp.php" : "http://app.ilam.ir";

//Jahrom
//let baseUrlWP_OR ="http://jahrom.iran137.com";

//MahalemaArak
//let baseUrlWP_OR ="http://ahvaz.iran137.com";
//let baseUrlWP_OR =Platform.OS==="web"?BASE_URL + "/proxy/arak/137/proxyapp.php" :"http://app.arak.ir/";


//Borazjan
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/borazjan/proxyapp.php" : "http://app.borazjan.ir";


//Roudan
//let baseUrlWP_OR = Platform.OS === "web" ? URL_PWA + "/proxy/roudan/proxyapp.php" : "http://app.roudancity.ir";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/roudan/proxyapp.php" : "http://app.roudancity.ir";
//let baseUrlWP_OR = "https://app.roudancity.ir";

//Maraghe
//let baseUrlWP_OR = Platform.OS === "web" ? URL_PWA + "/proxy/maraghe/proxyapp.php" : "http://app.maraghe.com";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/maraghe/proxyapp.php" : "http://app.maraghe.com";
//let baseUrlWP_OR = "https://app.maraghe.com/";

//Khorramshahr
//let baseUrlWP_OR = Platform.OS === "web" ? URL_PWA + "/proxy/khorramshahr/proxyapp.php" : "http://app.khorramshahr.ir";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/khorramshahr/proxyapp.php" : "http://app.khorramshahr.ir";
//let baseUrlWP_OR = "https://app.khorramshahr.ir/";

//Bushehr
//let baseUrlWP_OR = Platform.OS === "web" ? URL_PWA + "/proxy/bushehr/proxyapp.php" : "http://app.bushehr.ir";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/bushehr/proxyapp.php" : "http://app.bushehr.ir";
//let baseUrlWP_OR = "https://app.bushehr.ir/";

//Gerash
//let baseUrlWP_OR = Platform.OS === "web" ? URL_PWA + "/proxy/gerash/proxyapp.php" : "http://app.gerash.ir";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/gerash/proxyapp.php" : "http://app.gerash.ir";
//let baseUrlWP_OR = "https://app.gerash.ir/";

//Behbahan
//let baseUrlWP_OR = Platform.OS === "web" ? URL_PWA + "/proxy/behbahan/proxyapp.php" : "http://app.behbahan.ir";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/behbahan/proxyapp.php" : "http://app.behbahan.ir";

//Boumehen
//let baseUrlWP_OR = Platform.OS === "web" ? URL_PWA + "/proxy/behbahan/proxyapp.php" : "http://app.sh-boumehen.ir";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/behbahan/proxyapp.php" : "http://app.sh-boumehen.ir";

//Zarghan
//let baseUrlWP_OR = Platform.OS === "web" ? URL_PWA + "/proxy/zarghan/proxyapp.php" : "http://app.zarghan.ir";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/zarghan/proxyapp.php" : "http://app.zarghan.ir";

//Lavasan
//let baseUrlWP_OR = Platform.OS === "web" ? URL_PWA + "/proxy/lavasan/proxyapp.php" : "http://app.lavasan.ir";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/lavasan/proxyapp.php" : "http://app.lavasan.ir";

//Abadeh
//let baseUrlWP_OR = Platform.OS === "web" ? URL_PWA + "/proxy/abadeh/proxyapp.php" : "http://app.sh-abadeh.ir";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/abadeh/proxyapp.php" : "http://app.sh-abadeh.ir";


//Cloud
//let baseUrlWP_OR = Platform.OS === "web" ? URL_PWA + "/proxy/cloud/proxyapp.php" : "http://app.arak.ir";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/cloud/proxyapp.php" : "http://pwa137.satia.co";
let baseUrlWP_OR = "https://web.hormozgan.me/";

//Shahrman
// let baseUrlWP_OR = Platform.OS === "web" ? URL_PWA + "/proxy/shahrman/proxyapp.php" : "http://wp137.satia.co";
//let baseUrlWP_OR = Platform.OS === "web" ? BASE_URL + "/proxy/shahrman/proxyapp.php" : "http://wp137.satia.co";
//let baseUrlWP_OR = "https://app.shahrman.ir/";

let _baseUrlSaina = BASE_URLS + '/modules/CustomerPortal/api.php';
let _baseUrl125 = BASE_URLS_125 + '/modules/CustomerPortal/api.php';

export const typeExport = {
    // BASE_URL_Map: Platform.OS==="web"?BASE_URL+"/proxymap.php/service.asmx": 'http://185.113.56.12:8082/service.asmx',
    BASE_URL_Map: 'http://185.113.56.12:8082/service.asmx',

    _Version: DeviceInfo ? DeviceInfo.getVersion() + "" : "24",

    _Count: 10,
    _Count2: 20,
    SET_USER: 'SET_USER',

    SERVICE_TOKEN: 'SERVICE_TOKEN',
    SERVICE_USER: 'SERVICE_USER',
    SERVICE_CITY: 'SERVICE_CITY',
    SERVICE_WALLET: 'SERVICE_WALLET',


//SEARCH
    SEARCH_SERVICE_PENDING: 'SEARCH_SERVICE_PENDING',
    SEARCH_SERVICE_ERROR: 'SEARCH_SERVICE_ERROR',
    SEARCH_SERVICE_SUCCESS: 'SEARCH_SERVICE_SUCCESS',
    SEARCH_SERVICE_REFRESH: 'SEARCH_SERVICE_REFRESH',
    SEARCH_SERVICE_REFRESH_ALL: 'SEARCH_SERVICE_REFRESH_ALL',
    SEARCH_SERVICE_END: 'SEARCH_SERVICE_END',
    SEARCH_SERVICE_Empty: 'SEARCH_SERVICE_Empty',
    SEARCH_SERVICE_SELECT_CATEGORY: 'SEARCH_SERVICE_SELECT_CATEGORY',


//SPLASH_
    SPLASH_SERVICE_ERROR_Background: 'SPLASH_SERVICE_ERROR_Background',
    SPLASH_SERVICE_PENDING_Background: 'SPLASH_SERVICE_PENDING_Background',
    SPLASH_SERVICE_PENDING: 'SPLASH_SERVICE_PENDING',
    SPLASH_SERVICE_ERROR: 'SPLASH_SERVICE_ERROR',
    SPLASH_SERVICE_SUCCESS: 'SPLASH_SERVICE_SUCCESS',
    SPLASH_SERVICE_PENDING_Saina: 'SPLASH_SERVICE_PENDING_Saina',
    SPLASH_SERVICE_ERROR_Saina: 'SPLASH_SERVICE_ERROR_Saina',
    SPLASH_SERVICE_SUCCESS_Saina: 'SPLASH_SERVICE_SUCCESS_Saina',

    SPLASH_SERVICE_PENDING_Satia: 'SPLASH_SERVICE_PENDING_Satia',
    SPLASH_SERVICE_ERROR_Satia: 'SPLASH_SERVICE_ERROR_Satia',
    SPLASH_SERVICE_SUCCESS_Satia: 'SPLASH_SERVICE_SUCCESS_Satia',
    SPLASH_SERVICE_PENDING_Shahrdar: 'SPLASH_SERVICE_PENDING_Shahrdar',
    SPLASH_SERVICE_ERROR_Shahrdar: 'SPLASH_SERVICE_ERROR_Shahrdar',
    SPLASH_SERVICE_SUCCESS_Shahrdar: 'SPLASH_SERVICE_SUCCESS_Shahrdar',
    SPLASH_SERVICE_PENDING_125: 'SPLASH_SERVICE_PENDING_125',
    SPLASH_SERVICE_ERROR_125: 'SPLASH_SERVICE_ERROR_125',
    SPLASH_SERVICE_SUCCESS_125: 'SPLASH_SERVICE_SUCCESS_125',
    SPLASH_SERVICE_REFRESH: 'SPLASH_SERVICE_REFRESH',
    SPLASH_SERVICE_PENDING_CITY: 'SPLASH_SERVICE_PENDING_CITY',
    SPLASH_SERVICE_ERROR_CITY: 'SPLASH_SERVICE_ERROR_CITY',
    SERVICE_SUCCESS_GET_CITY_DATA: 'SERVICE_SUCCESS_GET_CITY_DATA',
    SERVICE_SUCCESS_SET_CITY_STATE: 'SERVICE_SUCCESS_SET_CITY_STATE',
    SERVICE_SUCCESS_SET_CITY: 'SERVICE_SUCCESS_SET_CITY',
    SERVICE_SUCCESS_SET_State: 'SERVICE_SUCCESS_SET_State',
    SERVICE_SUCCESS_SET_INFORMATION_USER: 'SERVICE_SUCCESS_SET_INFORMATION_USER',
    SERVICE_SUCCESS_SET_INFORMATION_DOCTOR: 'SERVICE_SUCCESS_SET_INFORMATION_DOCTOR',

    SPLASH_SUCCESS_GET_CITY_DATA: 'SPLASH_SUCCESS_GET_CITY_DATA',
    SPLASH_TOKEN: 'SPLASH_TOKEN',
    SPLASH_TOKEN_LARAVEL: 'SPLASH_TOKEN_LARAVEL',
    SPLASH_TOKEN_MAHALEH: 'SPLASH_TOKEN_MAHALEH',
    SPLASH_USER: 'SPLASH_USER',
    SPLASH_WALLET: 'SPLASH_WALLET',
    SPLASH_CITY: 'SPLASH_CITY',

    SERVICE_UserPassWifi: "SERVICE_UserPassWifi",
    SERVICE_NameDynamic: "SERVICE_NameDynamic",

    SERVICE_ConnectionInternetHotspot: "SERVICE_ConnectionInternetHotspot",

    _UserPassWifi: "_UserPassWifi",
    SERVICE_TIME_SPAN: "SERVICE_TIME_SPAN",

//ORDER LIST SCREEN

    OREDERLIST_SERVICE_PENDING: 'OREDERLIST_SERVICE_PENDING',
    OREDERLIST_SERVICE_ERROR: 'OREDERLIST_SERVICE_ERROR',
    OREDERLIST_SERVICE_SUCCESS: 'OREDERLIST_SERVICE_SUCCESS',
    OREDERLIST_SERVICE_REFRESH: 'OREDERLIST_SERVICE_REFRESH',
    OREDERLIST_SERVICE_END: 'OREDERLIST_SERVICE_END',
    OREDERLIST_SERVICE_EMPTY: 'OREDERLIST_SERVICE_EMPTY',


    RECEIVE_STATE: 'RECEIVE_STATE',
    RECEIVE_TOKEN: 'RECEIVE_TOKEN',
    RECEIVE_DETAIL_STATE: 'RECEIVE_DETAIL_STATE',
    RECEIVE_RESULTS: 'RECEIVE_RESULTS',
    CHANGE_CONNECTION_STATUS: 'CHANGE_CONNECTION_STATUS',


    LoginEnterPhoneScreen_SERVICE_PENDING: 'LoginEnterPhoneScreen_SERVICE_PENDING',
    LoginEnterPhoneScreen_SERVICE_ERROR: 'LoginEnterPhoneScreen_SERVICE_ERROR',
    LoginEnterPhoneScreen_SERVICE_SUCCESS: 'LoginEnterPhoneScreen_SERVICE_SUCCESS',
    LoginEnterPhoneScreen_SERVICE_REFRESH: 'LoginEnterPhoneScreen_SERVICE_REFRESH',
    LoginEnterPhoneScreen_SERVICE_END: 'LoginEnterPhoneScreen_SERVICE_END',
    LoginEnterPhoneScreen_SERVICE_Empty: 'LoginEnterPhoneScreen_SERVICE_Empty',

    LoginScreen_SERVICE_PENDING: 'LoginScreen_SERVICE_PENDING',
    LoginScreen_SERVICE_ERROR: 'LoginScreen_SERVICE_ERROR',
    LoginScreen_SERVICE_SUCCESS: 'LoginScreen_SERVICE_SUCCESS',
    LoginScreen_SERVICE_REFRESH: 'LoginScreen_SERVICE_REFRESH',
    LoginScreen_SERVICE_END: 'LoginScreen_SERVICE_END',
    LoginScreen_SERVICE_Empty: 'LoginScreen_SERVICE_Empty',

    LoginEnterPhoneCodeScreen_SERVICE_PENDING: 'LoginEnterPhoneCodeScreen_SERVICE_PENDING',
    LoginEnterPhoneCodeScreen_SERVICE_ERROR: 'LoginEnterPhoneCodeScreen_SERVICE_ERROR',
    LoginEnterPhoneCodeScreen_SERVICE_SUCCESS: 'LoginEnterPhoneCodeScreen_SERVICE_SUCCESS',
    LoginEnterPhoneCodeScreen_SERVICE_REFRESH: 'LoginEnterPhoneCodeScreen_SERVICE_REFRESH',
    LoginEnterPhoneCodeScreen_SERVICE_END: 'LoginEnterPhoneCodeScreen_SERVICE_END',
    LoginEnterPhoneCodeScreen_SERVICE_Empty: 'LoginEnterPhoneCodeScreen_SERVICE_Empty',
//EnterCodeScreen
    EnterCodeScreen_SERVICE_PENDING: 'EnterCodeScreen_SERVICE_PENDING',
    EnterCodeScreen_SERVICE_ERROR: 'EnterCodeScreen_SERVICE_ERROR',
    EnterCodeScreen_SERVICE_SUCCESS: 'EnterCodeScreen_SERVICE_SUCCESS',
    EnterCodeScreen_SERVICE_REFRESH: 'EnterCodeScreen_SERVICE_REFRESH',
    EnterCodeScreen_SERVICE_END: 'EnterCodeScreen_SERVICE_END',
    EnterCodeScreen_SERVICE_Empty: 'EnterCodeScreen_SERVICE_Empty',

//InformationScreen
    InformationScreen_SERVICE_PENDING: 'InformationScreen_SERVICE_PENDING',
    InformationScreen_SERVICE_ERROR: 'InformationScreen_SERVICE_ERROR',
    InformationScreen_SERVICE_SUCCESS: 'InformationScreen_SERVICE_SUCCESS',
    InformationScreen_SERVICE_REFRESH: 'InformationScreen_SERVICE_REFRESH',
    InformationScreen_SERVICE_END: 'InformationScreen_SERVICE_END',
    InformationScreen_SERVICE_Empty: 'InformationScreen_SERVICE_Empty',

//satia

//LoginSatiaScreen
    TypegetDataLoginEnterPhoneCodeSatiaScreen: "TypegetDataLoginEnterPhoneCodeSatiaScreen",
    urlGetLoginEnterPhoneCodeSatiaScreen: _baseUrlSaina,
    LoginEnterPhoneSatiaScreen_SERVICE_PENDING: 'LoginEnterPhoneSatiaScreen_SERVICE_PENDING',
    LoginEnterPhoneSatiaScreen_SERVICE_ERROR: 'LoginEnterPhoneSatiaScreen_SERVICE_ERROR',
    LoginEnterPhoneSatiaScreen_SERVICE_SUCCESS: 'LoginEnterPhoneSatiaScreen_SERVICE_SUCCESS',
    LoginEnterPhoneSatiaScreen_SERVICE_REFRESH: 'LoginEnterPhoneSatiaScreen_SERVICE_REFRESH',
    LoginEnterPhoneSatiaScreen_SERVICE_END: 'LoginEnterPhoneSatiaScreen_SERVICE_END',
    LoginEnterPhoneSatiaScreen_SERVICE_Empty: 'LoginEnterPhoneSatiaScreen_SERVICE_Empty',


    //LoginEnterUsernameSatiaScreen
    TypegetDataLoginEnterUsernameSatiaScreen: "TypegetDataLoginEnterUsernameSatiaScreen",
    urlGetLoginEnterUsernameSatiaScreen: _baseUrlSaina,
    LoginEnterUsernameSatiaScreen_SERVICE_PENDING: 'LoginEnterUsernameSatiaScreen_SERVICE_PENDING',
    LoginEnterUsernameSatiaScreen_SERVICE_ERROR: 'LoginEnterUsernameSatiaScreen_SERVICE_ERROR',
    LoginEnterUsernameSatiaScreen_SERVICE_SUCCESS: 'LoginEnterUsernameSatiaScreen_SERVICE_SUCCESS',
    LoginEnterUsernameSatiaScreen_SERVICE_REFRESH: 'LoginEnterUsernameSatiaScreen_SERVICE_REFRESH',
    LoginEnterUsernameSatiaScreen_SERVICE_END: 'LoginEnterUsernameSatiaScreen_SERVICE_END',
    LoginEnterUsernameSatiaScreen_SERVICE_Empty: 'LoginEnterUsernameSatiaScreen_SERVICE_Empty',


    LoginSatiaScreen_SERVICE_PENDING: 'LoginSatiaScreen_SERVICE_PENDING',
    LoginSatiaScreen_SERVICE_ERROR: 'LoginSatiaScreen_SERVICE_ERROR',
    LoginSatiaScreen_SERVICE_SUCCESS: 'LoginSatiaScreen_SERVICE_SUCCESS',
    LoginSatiaScreen_SERVICE_REFRESH: 'LoginSatiaScreen_SERVICE_REFRESH',
    LoginSatiaScreen_SERVICE_END: 'LoginSatiaScreen_SERVICE_END',
    LoginSatiaScreen_SERVICE_Empty: 'LoginSatiaScreen_SERVICE_Empty',
    LoginEnterPhoneCodeSatiaScreen_SERVICE_PENDING: 'LoginEnterPhoneCodeSatiaScreen_SERVICE_PENDING',
    LoginEnterPhoneCodeSatiaScreen_SERVICE_ERROR: 'LoginEnterPhoneCodeSatiaScreen_SERVICE_ERROR',
    LoginEnterPhoneCodeSatiaScreen_SERVICE_SUCCESS: 'LoginEnterPhoneCodeSatiaScreen_SERVICE_SUCCESS',
    LoginEnterPhoneCodeSatiaScreen_SERVICE_REFRESH: 'LoginEnterPhoneCodeSatiaScreen_SERVICE_REFRESH',
    LoginEnterPhoneCodeSatiaScreen_SERVICE_END: 'LoginEnterPhoneCodeSatiaScreen_SERVICE_END',
    LoginEnterPhoneCodeSatiaScreen_SERVICE_Empty: 'LoginEnterPhoneCodeSatiaScreen_SERVICE_Empty',


//EnterCodeScreen
    EnterCodeSatiaScreen_SERVICE_PENDING: 'EnterCodeSatiaScreen_SERVICE_PENDING',
    EnterCodeSatiaScreen_SERVICE_ERROR: 'EnterCodeSatiaScreen_SERVICE_ERROR',
    EnterCodeSatiaScreen_SERVICE_SUCCESS: 'EnterCodeSatiaScreen_SERVICE_SUCCESS',
    EnterCodeSatiaScreen_SERVICE_REFRESH: 'EnterCodeSatiaScreen_SERVICE_REFRESH',
    EnterCodeSatiaScreen_SERVICE_END: 'EnterCodeSatiaScreen_SERVICE_END',
    EnterCodeSatiaScreen_SERVICE_Empty: 'EnterCodeSatiaScreen_SERVICE_Empty',

//InformationSatiaScreen
    InformationSatiaScreen_SERVICE_PENDING: 'InformationSatiaScreen_SERVICE_PENDING',
    InformationSatiaScreen_SERVICE_ERROR: 'InformationSatiaScreen_SERVICE_ERROR',
    InformationSatiaScreen_SERVICE_SUCCESS: 'InformationSatiaScreen_SERVICE_SUCCESS',
    InformationSatiaScreen_SERVICE_REFRESH: 'InformationSatiaScreen_SERVICE_REFRESH',
    InformationSatiaScreen_SERVICE_END: 'InformationSatiaScreen_SERVICE_END',
    InformationSatiaScreen_SERVICE_Empty: 'InformationSatiaScreen_SERVICE_Empty',


    //UploadDocumentSatiaScreen
    TypeGetUploadDocumentSatiaScreen: "TypeGetUploadDocumentSatiaScreen",
    TypeSetUploadDocumentSatiaScreen: "TypeSetUploadDocumentSatiaScreen",
    urlUploadDocumentSatiaScreen: BASE_URL_SATIA + "user/listFiles",
    urlSetUploadDocumentSatiaScreen: '/api/applyNotify',
    UploadDocumentSatiaScreen_SERVICE_PENDING: 'UploadDocumentSatiaScreen_SERVICE_PENDING',
    UploadDocumentSatiaScreen_SERVICE_ERROR: 'UploadDocumentSatiaScreen_SERVICE_ERROR',
    UploadDocumentSatiaScreen_SERVICE_SUCCESS: 'UploadDocumentSatiaScreen_SERVICE_SUCCESS',
    UploadDocumentSatiaScreen_SERVICE_REFRESH: 'UploadDocumentSatiaScreen_SERVICE_REFRESH',
    UploadDocumentSatiaScreen_SERVICE_END: 'UploadDocumentSatiaScreen_SERVICE_END',
    UploadDocumentSatiaScreen_SERVICE_Empty: 'UploadDocumentSatiaScreen_SERVICE_Empty',


    MyApplyScreen_SERVICE_PENDING: 'MyApplyScreen_SERVICE_PENDING',
    MyApplyScreen_SERVICE_ERROR: 'MyApplyScreen_SERVICE_ERROR',
    MyApplyScreen_SERVICE_SUCCESS: 'MyApplyScreen_SERVICE_SUCCESS',
    MyApplyScreen_SERVICE_REFRESH: 'MyApplyScreen_SERVICE_REFRESH',
    MyApplyScreen_SERVICE_END: 'MyApplyScreen_SERVICE_END',
    MyApplyScreen_SERVICE_Empty: 'MyApplyScreen_SERVICE_Empty',
    MyApplyScreen_SERVICE_ADD_FIRST_DATA: 'MyApplyScreen_SERVICE_ADD_FIRST_DATA',


//InformationScreen
    ChangeInformationScreen_SERVICE_PENDING: 'ChangeInformationScreen_SERVICE_PENDING',
    ChangeInformationScreen_SERVICE_ERROR: 'ChangeInformationScreen_SERVICE_ERROR',
    ChangeInformationScreen_SERVICE_SUCCESS: 'ChangeInformationScreen_SERVICE_SUCCESS',
    ChangeInformationScreen_SERVICE_REFRESH: 'ChangeInformationScreen_SERVICE_REFRESH',
    ChangeInformationScreen_SERVICE_END: 'ChangeInformationScreen_SERVICE_END',
    ChangeInformationScreen_SERVICE_Empty: 'ChangeInformationScreen_SERVICE_Empty',
    ChangeInformationScreen_SERVICE_PENDING_SET: 'ChangeInformationScreen_SERVICE_PENDING_SET',
    ChangeInformationScreen_SERVICE_ERROR_SET: 'ChangeInformationScreen_SERVICE_ERROR_SET',
    ChangeInformationScreen_SERVICE_SUCCESS_SET: 'ChangeInformationScreen_SERVICE_SUCCESS_SET',
    ChangeInformationScreen_SERVICE_REFRESH_SET: 'ChangeInformationScreen_SERVICE_REFRESH_SET',
    ChangeInformationScreen_SERVICE_END_SET: 'ChangeInformationScreen_SERVICE_END_SET',
    ChangeInformationScreen_SERVICE_Empty_SET: 'ChangeInformationScreen_SERVICE_Empty_SET',

//ChangeInformationSatiaScreen
    ChangeInformationSatiaScreen_SERVICE_PENDING: 'ChangeInformationSatiaScreen_SERVICE_PENDING',
    ChangeInformationSatiaScreen_SERVICE_ERROR: 'ChangeInformationSatiaScreen_SERVICE_ERROR',
    ChangeInformationSatiaScreen_SERVICE_SUCCESS: 'ChangeInformationSatiaScreen_SERVICE_SUCCESS',
    ChangeInformationSatiaScreen_SERVICE_REFRESH: 'ChangeInformationSatiaScreen_SERVICE_REFRESH',
    ChangeInformationSatiaScreen_SERVICE_END: 'ChangeInformationSatiaScreen_SERVICE_END',
    ChangeInformationSatiaScreen_SERVICE_Empty: 'ChangeInformationSatiaScreen_SERVICE_Empty',
    ChangeInformationSatiaScreen_SERVICE_PENDING_SET: 'ChangeInformationSatiaScreen_SERVICE_PENDING_SET',
    ChangeInformationSatiaScreen_SERVICE_ERROR_SET: 'ChangeInformationSatiaScreen_SERVICE_ERROR_SET',
    ChangeInformationSatiaScreen_SERVICE_SUCCESS_SET: 'ChangeInformationSatiaScreen_SERVICE_SUCCESS_SET',
    ChangeInformationSatiaScreen_SERVICE_REFRESH_SET: 'ChangeInformationSatiaScreen_SERVICE_REFRESH_SET',
    ChangeInformationSatiaScreen_SERVICE_END_SET: 'ChangeInformationSatiaScreen_SERVICE_END_SET',
    ChangeInformationSatiaScreen_SERVICE_Empty_SET: 'ChangeInformationSatiaScreen_SERVICE_Empty_SET',

//CompetitionScreen
    CompetitionScreen_SERVICE_PENDING: 'CompetitionScreen_SERVICE_PENDING',
    CompetitionScreen_SERVICE_ERROR: 'CompetitionScreen_SERVICE_ERROR',
    CompetitionScreen_SERVICE_SUCCESS: 'CompetitionScreen_SERVICE_SUCCESS',
    CompetitionScreen_SERVICE_REFRESH: 'CompetitionScreen_SERVICE_REFRESH',
    CompetitionScreen_SERVICE_END: 'CompetitionScreen_SERVICE_END',
    CompetitionScreen_SERVICE_Empty: 'CompetitionScreen_SERVICE_Empty',
    CompetitionScreen_SERVICE_PENDING_SET: 'CompetitionScreen_SERVICE_PENDING_SET',
    CompetitionScreen_SERVICE_ERROR_SET: 'CompetitionScreen_SERVICE_ERROR_SET',
    CompetitionScreen_SERVICE_SUCCESS_SET: 'CompetitionScreen_SERVICE_SUCCESS_SET',
    CompetitionScreen_SERVICE_REFRESH_SET: 'CompetitionScreen_SERVICE_REFRESH_SET',
    CompetitionScreen_SERVICE_END_SET: 'CompetitionScreen_SERVICE_END_SET',
    CompetitionScreen_SERVICE_Empty_SET: 'CompetitionScreen_SERVICE_Empty_SET',

//CommentScreen
    MenuScreen_SERVICE_SET_PENDING: 'MenuScreen_SERVICE_SET_PENDING',
    MenuScreen_SERVICE_PENDING: 'MenuScreen_SERVICE_PENDING',
    MenuScreen_SERVICE_ERROR: 'MenuScreen_SERVICE_ERROR',
    MenuScreen_SERVICE_SUCCESS: 'MenuScreen_SERVICE_SUCCESS',
    MenuScreen_SERVICE_SET_SUCCESS: 'MenuScreen_SERVICE_SET_SUCCESS',
    MenuScreen_SERVICE_ERROR_SET: 'MenuScreen_SERVICE_ERROR_SET',

    MenuScreen_SERVICE_REFRESH_SET: 'MenuScreen_SERVICE_REFRESH_SET',
    MenuScreen_SERVICE_REFRESH: 'MenuScreen_SERVICE_REFRESH',
    MenuScreen_SERVICE_END: 'MenuScreen_SERVICE_END',
    MenuScreen_SERVICE_Empty: 'MenuScreen_SERVICE_Empty',
    MenuScreen_SERVICE_ADD_FIRST_DATA: 'MenuScreen_SERVICE_ADD_FIRST_DATA',
    MenuScreen_SERVICE_SELECT_CATEGORT: 'MenuScreen_SERVICE_SELECT_CATEGORT',
    MenuScreen_SERVICE_ADD_FILTER: 'MenuScreen_SERVICE_ADD_FILTER',
    MenuScreen_SERVICE_SUB_FILTER: 'MenuScreen_SERVICE_SUB_FILTER',
    MenuScreen_SERVICE_ModalFilterShow: 'MenuScreen_SERVICE_ModalFilterShow',

//FoodDetailsScreen
    FoodDetailsScreen_SERVICE_PENDING: 'FoodDetailsScreen_SERVICE_PENDING',
    FoodDetailsScreen_SERVICE_ERROR: 'FoodDetailsScreen_SERVICE_ERROR',
    FoodDetailsScreen_SERVICE_SUCCESS: 'FoodDetailsScreen_SERVICE_SUCCESS',
    FoodDetailsScreen_SERVICE_REFRESH: 'FoodDetailsScreen_SERVICE_REFRESH',

//StoreDetailsScreen
    StoreDetailsScreen_SERVICE_PENDING: 'StoreDetailsScreen_SERVICE_PENDING',
    StoreDetailsScreen_SERVICE_ERROR: 'StoreDetailsScreen_SERVICE_ERROR',
    StoreDetailsScreen_SERVICE_SUCCESS: 'StoreDetailsScreen_SERVICE_SUCCESS',
    StoreDetailsScreen_SERVICE_REFRESH: 'StoreDetailsScreen_SERVICE_REFRESH',

//ReservationScreen
    ReservationScreen_SERVICE_PENDING: 'ReservationScreen_SERVICE_PENDING',
    ReservationScreen_SERVICE_ERROR: 'ReservationScreen_SERVICE_ERROR',
    ReservationScreen_SERVICE_SUCCESS: 'ReservationScreen_SERVICE_SUCCESS',
    ReservationScreen_SERVICE_PENDING_Set: 'ReservationScreen_SERVICE_PENDING_Set',
    ReservationScreen_SERVICE_ERROR_Set: 'ReservationScreen_SERVICE_ERROR_Set',
    ReservationScreen_SERVICE_SUCCESS_Set: 'ReservationScreen_SERVICE_SUCCESS_Set',
    ReservationScreen_SERVICE_REFRESH: 'ReservationScreen_SERVICE_REFRESH',
    ReservationScreen_SERVICE_SELECT_CATEGORY: 'ReservationScreen_SERVICE_SELECT_CATEGORY',
    ReservationScreen_SERVICE_SELECT_Personnel: 'ReservationScreen_SERVICE_SELECT_Personnel',


//Pannel
    Pannel_SERVICE_PENDING: 'Pannel_ReservationScreen_SERVICE_PENDING',
    Pannel_SERVICE_ERROR: 'Pannel_ReservationScreen_SERVICE_ERROR',
    Pannel_SERVICE_SUCCESS: 'Pannel_ReservationScreen_SERVICE_SUCCES',
    Pannel_SERVICE_PENDING_Set: 'Pannel_ReservationScreen_SERVICE_PENDING_Set',
    Pannel_SERVICE_ERROR_Set: 'Pannel_ReservationScreen_SERVICE_ERROR_Set',
    Pannel_SERVICE_SUCCESS_Set: 'Pannel_ReservationScreen_SERVICE_SUCCESS_Set',
    Pannel_SERVICE_REFRESH: 'Pannel_ReservationScreen_SERVICE_REFRESH',
    Pannel_SERVICE_SELECT_CATEGORY: 'Pannel_ReservationScreen_SERVICE_SELECT_CATEGORY',
    Pannel_SERVICE_SELECT_Personnel: 'Pannel_ReservationScreen_SERVICE_SELECT_Personnel',


//DetailRestaurantScreen
    DetailRestaurantScreen_SERVICE_PENDING: 'DetailRestaurantScreen_SERVICE_PENDING',
    DetailRestaurantScreen_SERVICE_ERROR: '  DetailRestaurantScreen_SERVICE_ERROR',
    DetailRestaurantScreen_SERVICE_SUCCESS: 'DetailRestaurantScreen_SERVICE_SUCCESS',
    DetailRestaurantScreen_SERVICE_REFRESH: 'DetailRestaurantScreen_SERVICE_REFRESH',


    ADD_TO_CART: 'ADD_TO_CART',
    CHECKOUT_REQUEST: 'CHECKOUT_REQUEST',
    CHECKOUT_SUCCESS: 'CHECKOUT_SUCCESS',
    CHECKOUT_FAILURE: 'CHECKOUT_FAILURE',
    RECEIVE_PRODUCTS: 'RECEIVE_PRODUCTS',

//increase credit
    INCREASE_CREDIT_SERVICE_PENDING: 'INCREASE_CREDIT_SERVICE_PENDING',
    INCREASE_CREDIT_SERVICE_ERROR: 'INCREASE_CREDIT_SERVICE_ERROR',
    INCREASE_CREDIT_SERVICE_SUCCESS: 'INCREASE_CREDIT_SERVICE_SUCCESS',
    INCREASE_CREDIT_SERVICE_REFRESH: 'INCREASE_CREDIT_SERVICE_REFRESH',


//Messages_
    Messages_SERVICE_PENDING_Remove_Buy: 'Messages_SERVICE_PENDING_Remove_Buy',
    Messages_SERVICE_CLOSE_DIALOG_Remove_Buy: 'Messages_SERVICE_CLOSE_DIALOG_Remove_Buy',
    Messages_SERVICE_ERROR_Remove_Buy: 'Messages_SERVICE_ERROR_Remove_Buy',
    Messages_SERVICE_SUCCESS_Remove_Buy: 'Messages_SERVICE_SUCCESS_Remove_Buy',
    Messages_SERVICE_PENDING_Buy: 'Messages_SERVICE_PENDING_Buy',
    Messages_SERVICE_ERROR_Buy: 'Messages_SERVICE_ERROR_Buy',
    Messages_SERVICE_SUCCESS_Buy: 'Messages_SERVICE_SUCCESS_Buy',
    Messages_SERVICE_END_Buy: 'Messages_SERVICE_END_Buy',
    Messages_SERVICE_Empty_Buy: 'Messages_SERVICE_Empty_Buy',
    Messages_SERVICE_REFRESH_Buy: 'Messages_SERVICE_REFRESH_Buy',

    Messages_SERVICE_PENDING_Remove_Sell: 'Messages_SERVICE_PENDING_Remove_Sell',
    Messages_SERVICE_CLOSE_DIALOG_Remove_Sell: 'Messages_SERVICE_CLOSE_DIALOG_Remove_Sell',
    Messages_SERVICE_ERROR_Remove_Sell: 'Messages_SERVICE_ERROR_Remove_Sell',
    Messages_SERVICE_SUCCESS_Remove_Sell: 'Messages_SERVICE_SUCCESS_Remove_Sell',
    Messages_SERVICE_PENDING_Sell: 'Messages_SERVICE_PENDING_Sell',
    Messages_SERVICE_ERROR_Sell: 'Messages_SERVICE_ERROR_Sell',
    Messages_SERVICE_SUCCESS_Sell: 'Messages_SERVICE_SUCCESS_Sell',
    Messages_SERVICE_END_Sell: 'Messages_SERVICE_END_Sell',
    Messages_SERVICE_Empty_Sell: 'Messages_SERVICE_Empty_Sell',
    Messages_SERVICE_REFRESH_Sell: 'Messages_SERVICE_REFRESH_Sell',
    Messages_SERVICE_REFRESH: 'Messages_SERVICE_REFRESH',
    Messages_SERVICE_CHANGE_ITEM: 'Messages_SERVICE_CHANGE_ITEM',


    //_sendCode: "sendCode",

    SERVICE_Account: "SERVICE_Account",
    ListNews: "ListNews",
    ListCategory: "ListCategory",

    ListMyManInjamOffline: "ListMyManInjamOffline",
    ListMyManInjam: "ListMyManInjam",


    ListMyApplyOffline: "ListMyApplyOffline",
    ListMyApply: "ListMyApply",

    ListMyApplyOperationOffline: "ListMyApplyOperationOffline",
    ListMyApplyOperation: "ListMyApplyOperation",

    ListDeadOffline: "ListDeadOffline",
    ListDead: "ListDead",

    ListMyRegisterComplaintsOffline: "ListMyRegisterComplaintsOffline",
    ListMyRegisterComplaints: "ListMyRegisterComplaints",


    ListOperatorApplyOffline: "ListOperatorApplyOffline",
    ListOperatorApply: "ListOperatorApply",
    ListOperatorApplyFilter: "ListOperatorApplyFilter",


    //
    // ListMyManInjamOffline: "ListMyManInjamOffline",
    // ListMyManInjam: "ListMyManInjam",
    //
    //
    // ListMyApplyOffline: "ListMyApplyOffline",
    // ListMyApply: "ListMyApply",
    //
    // ListDeadOffline: "ListDeadOffline",
    // ListDead: "ListDead",
    //
    // ListMyRegisterComplaintsOffline: "ListMyRegisterComplaintsOffline",
    // ListMyRegisterComplaints: "ListMyRegisterComplaints",
    //
    //
    // ListOperatorApplyOffline: "ListOperatorApplyOffline",
    // ListOperatorApply: "ListOperatorApply",


    SERVICE_ListNotSendRegisterComplaints: "SERVICE_ListNotSendRegisterComplaints",
    SERVICE_ListNotSendMyApply: "SERVICE_ListNotSendMyApply",
    SERVICE_NotSendListOperatorApply: "SERVICE_NotSendListOperatorApply",
    SERVICE_Location: "SERVICE_Location",
    SERVICE_TypeLogin: "SERVICE_TypeLogin",
    SERVICE_wifiIsEnabled: "SERVICE_wifiIsEnabled",
    SERVICE_wifiConnectionStatus: "SERVICE_wifiConnectionStatus",
    SERVICE_Connection: "SERVICE_Connection",
    SERVICE_ConnectionType: "SERVICE_ConnectionType",
    SERVICE_SUB_CART: "SERVICE_SUB_CART",
    SERVICE_ADD_CART: 'SERVICE_ADD_CART',
    SERVICE_PRICE_ALL: 'SERVICE_PRICE_ALL',
    PayScreen_SERVICE_PENDING: 'PayScreen_SERVICE_PENDING',
    PayScreen_SERVICE_ERROR: 'PayScreen_SERVICE_ERROR',
    PayScreen_SERVICE_SUCCESS: 'PayScreen_SERVICE_SUCCESS',
    PayScreen_SERVICE_REFRESH: 'PayScreen_SERVICE_REFRES',

    PaySatiaScreen_SERVICE_PENDING: 'PaySatiaScreen_SERVICE_PENDING',
    PaySatiaScreen_SERVICE_ERROR: 'PaySatiaScreen_SERVICE_ERROR',
    PaySatiaScreen_SERVICE_SUCCESS: 'PaySatiaScreen_SERVICE_SUCCESS',
    PaySatiaScreen_SERVICE_REFRESH: 'PaySatiaScreen_SERVICE_REFRES',
    SERVICE_CLEAR_ALL_CART: 'SERVICE_CLEAR_ALL_CART',
    SERVICE_CHANGE_DISCOUNT: 'SERVICE_CHANGE_DISCOUNT',
    SERVICE_CHANGE_ITEM_DISCOUNT_FIRST: 'SERVICE_CHANGE_ITEM_DISCOUNT_FIRST',
    SERVICE_CHANGE_ITEM_Opinion: 'SERVICE_CHANGE_ITEM_Opinion',
    SERVICE_RestaurantBasketCheck: 'SERVICE_RestaurantBasketCheck',
    SERVICE_Rtl: 'SERVICE_Rtl',
    SERVICE_Lang: 'SERVICE_Lang',
    SERVICE_Background: 'SERVICE_Background',
    SERVICE_ChangeNotifUser: 'SERVICE_ChangeNotifUser',
    SERVICE_TokenFirebase: 'SERVICE_TokenFirebase',
    SERVICE_STATE: 'SERVICE_STATE',


    SetPannelDetailStoreScreen_SERVICE_PENDING: 'SetPannelDetailStoreScreen_SERVICE_PENDING',
    SetPannelDetailStoreScreen_SERVICE_ERROR: 'SetPannelDetailStoreScreen_SERVICE_ERROR',
    SetPannelDetailStoreScreen_SERVICE_SUCCESS: 'SetPannelDetailStoreScreen_SERVICE_SUCCESS',
    PannelDetailStoreScreen_SERVICE_PENDING: 'PannelDetailStoreScreen_SERVICE_PENDING',
    PannelDetailStoreScreen_SERVICE_ERROR: 'PannelDetailStoreScreen_SERVICE_ERROR',
    PannelDetailStoreScreen_SERVICE_SUCCESS: 'PannelDetailStoreScreen_SERVICE_SUCCESS',
    PannelDetailStoreScreen_SERVICE_REFRESH: 'PannelDetailStoreScreen_SERVICE_REFRESHs',


    SetPannelDetailAdminScreen_SERVICE_PENDING: 'SetPannelDetailAdminScreen_SERVICE_PENDING',
    SetPannelDetailAdminScreen_SERVICE_ERROR: 'SetPannelDetailAdminScreen_SERVICE_ERROR',
    SetPannelDetailAdminScreen_SERVICE_SUCCESS: 'SetPannelDetailAdminScreen_SERVICE_SUCCESS',
    PannelDetailAdminScreen_SERVICE_PENDING: 'PannelDetailAdminScreen_SERVICE_PENDING',
    PannelDetailAdminScreen_SERVICE_ERROR: 'PannelDetailAdminScreen_SERVICE_ERROR',
    PannelDetailAdminScreen_SERVICE_SUCCESS: 'PannelDetailAdminScreen_SERVICE_SUCCESS',
    PannelDetailAdminScreen_SERVICE_REFRESH: 'PannelDetailAdminScreen_SERVICE_REFRESHs',


    SetMyApplyScreen_SERVICE_PENDING: 'SetMyApplyScreen_SERVICE_PENDING',
    SetMyApplyScreen_SERVICE_ERROR: 'SetMyApplyScreen_SERVICE_ERROR',
    SetMyApplyScreen_SERVICE_SUCCESS: 'SetMyApplyScreen_SERVICE_SUCCESS',
    MyApplyScreen_SERVICE_CHANGE_NOTIF: 'MyApplyScreen_SERVICE_CHANGE_NOTIF',


    TypeGetListNewsScreen: "TypeGetListNewsScreen",
    TypeSetListNewsScreen: "TypeSetListNewsScreen",
    urlListNewsScreen: `/api/myApplies`,
    urlSetListNewsScreen: `/api/applyNotify`,
    SetListNewsScreen_SERVICE_PENDING: 'SetListNewsScreen_SERVICE_PENDING',
    SetListNewsScreen_SERVICE_ERROR: 'SetListNewsScreen_SERVICE_ERROR',
    SetListNewsScreen_SERVICE_SUCCESS: 'SetListNewsScreen_SERVICE_SUCCESS',
    ListNewsScreen_SERVICE_CHANGE_NOTIF: 'ListNewsScreen_SERVICE_CHANGE_NOTIF',
    ListNewsScreen_SERVICE_PENDING: 'ListNewsScreen_SERVICE_PENDING',
    ListNewsScreen_SERVICE_ERROR: 'ListNewsScreen_SERVICE_ERROR',
    ListNewsScreen_SERVICE_SUCCESS: 'ListNewsScreen_SERVICE_SUCCESS',
    ListNewsScreen_SERVICE_REFRESH: 'ListNewsScreen_SERVICE_REFRESH',
    ListNewsScreen_SERVICE_END: 'ListNewsScreen_SERVICE_END',
    ListNewsScreen_SERVICE_Empty: 'ListNewsScreen_SERVICE_Empty',
    ListNewsScreen_SERVICE_ADD_FIRST_DATA: 'ListNewsScreen_SERVICE_ADD_FIRST_DATA',

    FinalRequestScreen_SERVICE_PENDING: 'FinalRequestScreen_SERVICE_PENDING',
    FinalRequestScreen_SERVICE_ERROR: 'FinalRequestScreen_SERVICE_ERROR',
    FinalRequestScreen_SERVICE_SUCCESS: 'FinalRequestScreen_SERVICE_SUCCESS',
    SetFinalRequestScreen_SERVICE_PENDING: 'SetFinalRequestScreen_SERVICE_PENDING',
    SetFinalRequestScreen_SERVICE_ERROR: 'SetFinalRequestScreen_SERVICE_ERROR',
    SetFinalRequestScreen_SERVICE_SUCCESS: 'SetFinalRequestScreen_SERVICE_SUCCESS',
    FinalRequestScreen_SERVICE_REFRESH: 'FinalRequestScreen_SERVICE_REFRESH',
    FinalRequestScreen_SERVICE_END: 'FinalRequestScreen_SERVICE_END',
    FinalRequestScreen_SERVICE_Empty: 'FinalRequestScreen_SERVICE_Empty',
    FinalRequestScreen_SERVICE_ADD_FIRST_DATA: 'FinalRequestScreen_SERVICE_ADD_FIRST_DATA',

    //  MenuDrawer
    SetMenuDrawer_SERVICE_PENDING: 'SetMenuDrawer_SERVICE_PENDING',
    SetMenuDrawer_SERVICE_ERROR: 'SetMenuDrawer_SERVICE_ERROR',
    SetMenuDrawer_SERVICE_SUCCESS: 'SetMenuDrawer_SERVICE_SUCCESS',
    MenuDrawer_SERVICE_PENDING: 'MenuDrawer_SERVICE_PENDING',
    MenuDrawer_SERVICE_ERROR: 'MenuDrawer_SERVICE_ERROR',
    MenuDrawer_SERVICE_SUCCESS: 'MenuDrawer_SERVICE_SUCCESS',
    MenuDrawer_SERVICE_REFRESH: 'MenuDrawer_SERVICE_REFRESH',

    //  ChangPssScreen
    SetChangPssScreen_SERVICE_PENDING: 'SetChangPssScreen_SERVICE_PENDING',
    SetChangPssScreen_SERVICE_ERROR: 'SetChangPssScreen_SERVICE_ERROR',
    SetChangPssScreen_SERVICE_SUCCESS: 'SetChangPssScreen_SERVICE_SUCCESS',
    ChangPssScreen_SERVICE_PENDING: 'ChangPssScreen_SERVICE_PENDING',
    ChangPssScreen_SERVICE_ERROR: 'ChangPssScreen_SERVICE_ERROR',
    ChangPssScreen_SERVICE_SUCCESS: 'ChangPssScreen_SERVICE_SUCCESS',
    ChangPssScreen_SERVICE_REFRESH: 'ChangPssScreen_SERVICE_REFRESH',


    //  SubmitRequestScreen
    //  urlGetSubmitRequest: '',
    TypeGetSubmitRequestScreen: 'TypeGetSubmitRequestScreen',
    TypeSetSubmitRequestScreen: 'TypeSetSubmitRequestScreen',
    SubmitRequestScreen_SERVICE_PENDING_Set: 'SubmitRequestScreen_SERVICE_PENDING_Set',
    SubmitRequestScreen_SERVICE_ERROR_Set: 'SubmitRequestScreen_SERVICE_ERROR_Set',
    SubmitRequestScreen_SERVICE_SUCCESS_Set: 'SubmitRequestScreen_SERVICE_SUCCESS_Set',
    SubmitRequestScreen_SERVICE_PENDING: 'SubmitRequestScreen_SERVICE_PENDING',
    SubmitRequestScreen_SERVICE_ERROR: 'SubmitRequestScreen_SERVICE_ERROR',
    SubmitRequestScreen_SERVICE_SUCCESS: 'SubmitRequestScreen_SERVICE_SUCCESS',
    SubmitRequestScreen_SERVICE_REFRESH: 'SubmitRequestScreen_SERVICE_REFRESH',


    //  SubmitRequestScreen22
    urlGetSubmitRequest22: '',
    TypeGetSubmitRequestScreen22: 'TypeGetSubmitRequestScreen22',
    TypeSetSubmitRequestScreen22: 'TypeSetSubmitRequestScreen22',
    SubmitRequestScreen22_SERVICE_PENDING_Set: 'SubmitRequestScreen22_SERVICE_PENDING_Set',
    SubmitRequestScreen22_SERVICE_ERROR_Set: 'SubmitRequestScreen22_SERVICE_ERROR_Set',
    SubmitRequestScreen22_SERVICE_SUCCESS_Set: 'SubmitRequestScreen22_SERVICE_SUCCESS_Set',
    SubmitRequestScreen22_SERVICE_PENDING: 'SubmitRequestScreen22_SERVICE_PENDING',
    SubmitRequestScreen22_SERVICE_ERROR: 'SubmitRequestScreen22_SERVICE_ERROR',
    SubmitRequestScreen22_SERVICE_SUCCESS: 'SubmitRequestScreen22_SERVICE_SUCCESS',
    SubmitRequestScreen22_SERVICE_REFRESH: 'SubmitRequestScreen22_SERVICE_REFRESH',


    //  SubmitSwitchingOperationScreen
    urlGetSubmitSwitchingOperationScreen: '',
    TypeGetSubmitSwitchingOperationScreen: 'TypeGetSubmitSwitchingOperationScreen',
    TypeSetSubmitSwitchingOperationScreen: 'TypeSetSubmitSwitchingOperationScreen',
    SubmitSwitchingOperationScreen_SERVICE_PENDING_Set: 'SubmitSwitchingOperationScreen_SERVICE_PENDING_Set',
    SubmitSwitchingOperationScreen_SERVICE_ERROR_Set: 'SubmitSwitchingOperationScreen_SERVICE_ERROR_Set',
    SubmitSwitchingOperationScreen_SERVICE_SUCCESS_Set: 'SubmitSwitchingOperationScreen_SERVICE_SUCCESS_Set',
    SubmitSwitchingOperationScreen_SERVICE_PENDING: 'SubmitSwitchingOperationScreen_SERVICE_PENDING',
    SubmitSwitchingOperationScreen_SERVICE_ERROR: 'SubmitSwitchingOperationScreen_SERVICE_ERROR',
    SubmitSwitchingOperationScreen_SERVICE_SUCCESS: 'SubmitSwitchingOperationScreen_SERVICE_SUCCESS',
    SubmitSwitchingOperationScreen_SERVICE_REFRESH: 'SubmitSwitchingOperationScreen_SERVICE_REFRESH',

    //  SubmitSendOperationScreen
    urlGetSubmitSendOperationScreen: '',
    urlSetSubmitSendOperationScreen: BASE_URLS + '/modules/Mobile/api.php',
    TypeGetSubmitSendOperationScreen: 'TypeGetSubmitSendOperationScreen',
    TypeSetSubmitSendOperationScreen: 'TypeSetSubmitSendOperationScreen',
    SubmitSendOperationScreen_SERVICE_PENDING_Set: 'SubmitSendOperationScreen_SERVICE_PENDING_Set',
    SubmitSendOperationScreen_SERVICE_ERROR_Set: 'SubmitSendOperationScreen_SERVICE_ERROR_Set',
    SubmitSendOperationScreen_SERVICE_SUCCESS_Set: 'SubmitSendOperationScreen_SERVICE_SUCCESS_Set',
    SubmitSendOperationScreen_SERVICE_PENDING: 'SubmitSendOperationScreen_SERVICE_PENDING',
    SubmitSendOperationScreen_SERVICE_ERROR: 'SubmitSendOperationScreen_SERVICE_ERROR',
    SubmitSendOperationScreen_SERVICE_SUCCESS: 'SubmitSendOperationScreen_SERVICE_SUCCESS',
    SubmitSendOperationScreen_SERVICE_REFRESH: 'SubmitSendOperationScreen_SERVICE_REFRESH',

    //  SubmitRequestScreen22
    urlGetSubmitRequestOperationScreen: '',
    TypeGetSubmitRequestOperationScreen: 'TypeGetSubmitRequestOperationScreen',
    TypeSetSubmitRequestOperationScreen: 'TypeSetSubmitRequestOperationScreen',
    SubmitRequestOperationScreen_SERVICE_PENDING_Set: 'SubmitRequestOperationScreen_SERVICE_PENDING_Set',
    SubmitRequestOperationScreen_SERVICE_ERROR_Set: 'SubmitRequestOperationScreen_SERVICE_ERROR_Set',
    SubmitRequestOperationScreen_SERVICE_SUCCESS_Set: 'SubmitRequestOperationScreen_SERVICE_SUCCESS_Set',
    SubmitRequestOperationScreen_SERVICE_PENDING: 'SubmitRequestOperationScreen_SERVICE_PENDING',
    SubmitRequestOperationScreen_SERVICE_ERROR: 'SubmitRequestOperationScreen_SERVICE_ERROR',
    SubmitRequestOperationScreen_SERVICE_SUCCESS: 'SubmitRequestOperationScreen_SERVICE_SUCCESS',
    SubmitRequestOperationScreen_SERVICE_REFRESH: 'SubmitRequestOperationScreen_SERVICE_REFRESH',

    //  SubmitRequestScreen22
    urlGetSubmitRequestOperationFireScreen: '',
    TypeGetSubmitRequestOperationFireScreen: 'TypeGetSubmitRequestOperationFireScreen',
    TypeSetSubmitRequestOperationFireScreen: 'TypeSetSubmitRequestOperationFireScreen',
    SubmitRequestOperationFireScreen_SERVICE_PENDING_Set: 'SubmitRequestOperationFireScreen_SERVICE_PENDING_Set',
    SubmitRequestOperationFireScreen_SERVICE_ERROR_Set: 'SubmitRequestOperationFireScreen_SERVICE_ERROR_Set',
    SubmitRequestOperationFireScreen_SERVICE_SUCCESS_Set: 'SubmitRequestOperationFireScreen_SERVICE_SUCCESS_Set',
    SubmitRequestOperationFireScreen_SERVICE_PENDING: 'SubmitRequestOperationFireScreen_SERVICE_PENDING',
    SubmitRequestOperationFireScreen_SERVICE_ERROR: 'SubmitRequestOperationFireScreen_SERVICE_ERROR',
    SubmitRequestOperationFireScreen_SERVICE_SUCCESS: 'SubmitRequestOperationFireScreen_SERVICE_SUCCESS',
    SubmitRequestOperationFireScreen_SERVICE_REFRESH: 'SubmitRequestOperationFireScreen_SERVICE_REFRESH',

    //  SubmitManInjamScreen
    urlGetSubmitManInjamScreen: '',
    TypeGetSubmitManInjamScreen: 'TypeGetSubmitManInjamScreen',
    TypeSetSubmitManInjamScreen: 'TypeSetSubmitManInjamScreen',
    SubmitManInjamScreen_SERVICE_PENDING_Set: 'SubmitManInjamScreen_SERVICE_PENDING_Set',
    SubmitManInjamScreen_SERVICE_ERROR_Set: 'SubmitManInjamScreen_SERVICE_ERROR_Set',
    SubmitManInjamScreen_SERVICE_SUCCESS_Set: 'SubmitManInjamScreen_SERVICE_SUCCESS_Set',
    SubmitManInjamScreen_SERVICE_PENDING: 'SubmitManInjamScreen_SERVICE_PENDING',
    SubmitManInjamScreen_SERVICE_ERROR: 'SubmitManInjamScreen_SERVICE_ERROR',
    SubmitManInjamScreen_SERVICE_SUCCESS: 'SubmitManInjamScreen_SERVICE_SUCCESS',
    SubmitManInjamScreen_SERVICE_REFRESH: 'SubmitManInjamScreen_SERVICE_REFRESH',

    //  PollScreen
    TypeGetPollScreen: 'TypeGetPollScreen',
    TypeSetPollScreen: 'TypeSetPollScreen',
    PollScreen_SERVICE_PENDING_Set: 'PollScreen_SERVICE_PENDING_Set',
    PollScreen_SERVICE_ERROR_Set: 'PollScreen_SERVICE_ERROR_Set',
    PollScreen_SERVICE_SUCCESS_Set: 'PollScreen_SERVICE_SUCCESS_Set',
    PollScreen_SERVICE_PENDING: 'PollScreen_SERVICE_PENDING',
    PollScreen_SERVICE_ERROR: 'PollScreen_SERVICE_ERROR',
    PollScreen_SERVICE_SUCCESS: 'PollScreen_SERVICE_SUCCESS',
    PollScreen_SERVICE_REFRESH: 'PollScreen_SERVICE_REFRESH',


    //  GraveyardScreen
    TypeGetGraveyardScreen: 'TypeGetGraveyardScreen',
    TypeSetGraveyardScreen: 'TypeSetGraveyardScreen',
    GraveyardScreen_SERVICE_PENDING_Set: 'GraveyardScreen_SERVICE_PENDING_Set',
    GraveyardScreen_SERVICE_ERROR_Set: 'GraveyardScreen_SERVICE_ERROR_Set',
    GraveyardScreen_SERVICE_SUCCESS_Set: 'GraveyardScreen_SERVICE_SUCCESS_Set',
    GraveyardScreen_SERVICE_PENDING: 'GraveyardScreen_SERVICE_PENDING',
    GraveyardScreen_SERVICE_ERROR: 'GraveyardScreen_SERVICE_ERROR',
    GraveyardScreen_SERVICE_SUCCESS: 'GraveyardScreen_SERVICE_SUCCESS',
    GraveyardScreen_SERVICE_REFRESH: 'GraveyardScreen_SERVICE_REFRESH',


    //  RegisterComplaintsScreen
    TypeGetRegisterComplaintsScreen: 'TypeGetRegisterComplaintsScreen',
    TypeSetRegisterComplaintsScreen: 'TypeSetRegisterComplaintsScreen',
    urlSetRegisterComplaintsScreen: BASE_URLS + '/modules/CustomerPortal/api.php',
    RegisterComplaintsScreen_SERVICE_PENDING_Set: 'RegisterComplaintsScreen_SERVICE_PENDING_Set',
    RegisterComplaintsScreen_SERVICE_ERROR_Set: 'RegisterComplaintsScreen_SERVICE_ERROR_Set',
    RegisterComplaintsScreen_SERVICE_SUCCESS_Set: 'RegisterComplaintsScreen_SERVICE_SUCCESS_Set',
    RegisterComplaintsScreen_SERVICE_PENDING: 'RegisterComplaintsScreen_SERVICE_PENDING',
    RegisterComplaintsScreen_SERVICE_ERROR: 'RegisterComplaintsScreen_SERVICE_ERROR',
    RegisterComplaintsScreen_SERVICE_SUCCESS: 'RegisterComplaintsScreen_SERVICE_SUCCESS',
    RegisterComplaintsScreen_SERVICE_REFRESH: 'RegisterComplaintsScreen_SERVICE_REFRESH',


    //  DetailsDeadScreen
    TypeGetDetailsDeadScreen: 'TypeGetDetailsDeadScreen',
    TypeSetDetailsDeadScreen: 'TypeSetDetailsDeadScreen',
    DetailsDeadScreen_SERVICE_PENDING_Set: 'DetailsDeadScreen_SERVICE_PENDING_Set',
    DetailsDeadScreen_SERVICE_ERROR_Set: 'DetailsDeadScreen_SERVICE_ERROR_Set',
    DetailsDeadScreen_SERVICE_SUCCESS_Set: 'DetailsDeadScreen_SERVICE_SUCCESS_Set',
    DetailsDeadScreen_SERVICE_PENDING: 'DetailsDeadScreen_SERVICE_PENDING',
    DetailsDeadScreen_SERVICE_ERROR: 'DetailsDeadScreen_SERVICE_ERROR',
    DetailsDeadScreen_SERVICE_SUCCESS: 'DetailsDeadScreen_SERVICE_SUCCESS',
    DetailsDeadScreen_SERVICE_REFRESH: 'DetailsDeadScreen_SERVICE_REFRESH',


    //  CategoryScreen
    UrlGetCategoryScreen: 'submenu',
    TypeGetCategoryScreen: 'TypeGetCategoryScreen',
    TypeSetCategoryScreen: 'TypeSetCategoryScreen',
    CategoryScreen_SERVICE_PENDING_Set: 'CategoryScreen_SERVICE_PENDING_Set',
    CategoryScreen_SERVICE_ERROR_Set: 'CategoryScreen_SERVICE_ERROR_Set',
    CategoryScreen_SERVICE_SUCCESS_Set: 'CategoryScreen_SERVICE_SUCCESS_Set',
    CategoryScreen_SERVICE_PENDING: 'CategoryScreen_SERVICE_PENDING',
    CategoryScreen_SERVICE_ERROR: 'CategoryScreen_SERVICE_ERROR',
    CategoryScreen_SERVICE_SUCCESS: 'CategoryScreen_SERVICE_SUCCESS',
    CategoryScreen_SERVICE_REFRESH: 'CategoryScreen_SERVICE_REFRESH',


    //  DetailsScreen


    TypeGetDetailsScreen: "TypeGetDetailsScreen",
    TypeSetDetailsScreen: "TypeSetDetailsScreen",
    urlDetailsScreen: `posts`,
    urlSetDetailsScreen: `/api/applyNotify`,
    DetailsScreen_SERVICE_PENDING_Set: 'DetailsScreen_SERVICE_PENDING_Set',
    DetailsScreen_SERVICE_ERROR_Set: 'DetailsScreen_SERVICE_ERROR_Set',
    DetailsScreen_SERVICE_SUCCESS_Set: 'DetailsScreen_SERVICE_SUCCESS_Set',
    DetailsScreen_SERVICE_PENDING: 'DetailsScreen_SERVICE_PENDING',
    DetailsScreen_SERVICE_ERROR: 'DetailsScreen_SERVICE_ERROR',
    DetailsScreen_SERVICE_SUCCESS: 'DetailsScreen_SERVICE_SUCCESS',
    DetailsScreen_SERVICE_REFRESH: 'DetailsScreen_SERVICE_REFRESH',


    //  ApplyScreen
    TypeGetApplyScreen: "TypeGetApplyScreen",
    TypeSetApplyScreen: "TypeSetApplyScreen",
    urlApplyScreen: BASE_URL_SN,
    urlSetApplyScreen: `/api/applyNotify`,
    ApplyScreen_SERVICE_PENDING_Set: 'ApplyScreen_SERVICE_PENDING_Set',
    ApplyScreen_SERVICE_ERROR_Set: 'ApplyScreen_SERVICE_ERROR_Set',
    ApplyScreen_SERVICE_SUCCESS_Set: 'ApplyScreen_SERVICE_SUCCESS_Set',
    ApplyScreen_SERVICE_PENDING: 'ApplyScreen_SERVICE_PENDING',
    ApplyScreen_SERVICE_ERROR: 'ApplyScreen_SERVICE_ERROR',
    ApplyScreen_SERVICE_SUCCESS: 'ApplyScreen_SERVICE_SUCCESS',
    ApplyScreen_SERVICE_REFRESH: 'ApplyScreen_SERVICE_REFRESH',


    //  QuestionFanoosScreen
    TypeGetQuestionFanoosScreen: "TypeGetQuestionFanoosScreen",
    TypeSetQuestionFanoosScreen: "TypeSetQuestionFanoosScreen",
    urlQuestionFanoosScreen: BASE_URL_SN,
    urlSetQuestionFanoosScreen: `/api/applyNotify`,
    QuestionFanoosScreen_SERVICE_PENDING_Set: 'QuestionFanoosScreen_SERVICE_PENDING_Set',
    QuestionFanoosScreen_SERVICE_ERROR_Set: 'QuestionFanoosScreen_SERVICE_ERROR_Set',
    QuestionFanoosScreen_SERVICE_SUCCESS_Set: 'QuestionFanoosScreen_SERVICE_SUCCESS_Set',
    QuestionFanoosScreen_SERVICE_PENDING: 'QuestionFanoosScreen_SERVICE_PENDING',
    QuestionFanoosScreen_SERVICE_ERROR: 'QuestionFanoosScreen_SERVICE_ERROR',
    QuestionFanoosScreen_SERVICE_SUCCESS: 'QuestionFanoosScreen_SERVICE_SUCCESS',
    QuestionFanoosScreen_SERVICE_REFRESH: 'QuestionFanoosScreen_SERVICE_REFRESH',


    //  ManInjam
    TypeGetManInjamScreen: "TypeGetManInjamScreen",
    TypeSetManInjamScreen: "TypeSetManInjamScreen",
    urlManInjamScreen: BASE_URL_SN,
    urlSetManInjamScreen: `/api/applyNotify`,
    ManInjamScreen_SERVICE_PENDING_Set: 'ManInjamScreen_SERVICE_PENDING_Set',
    ManInjamScreen_SERVICE_ERROR_Set: 'ManInjamScreen_SERVICE_ERROR_Set',
    ManInjamScreen_SERVICE_SUCCESS_Set: 'ManInjamScreen_SERVICE_SUCCESS_Set',
    ManInjamScreen_SERVICE_PENDING: 'ManInjamScreen_SERVICE_PENDING',
    ManInjamScreen_SERVICE_ERROR: 'ManInjamScreen_SERVICE_ERROR',
    ManInjamScreen_SERVICE_SUCCESS: 'ManInjamScreen_SERVICE_SUCCESS',
    ManInjamScreen_SERVICE_REFRESH: 'ManInjamScreen_SERVICE_REFRESH',

    //  DetailsOperatorApply
    TypeSendGetDetailsOperatorApplyScreen: "TypeSendGetDetailsOperatorApplyScreen",
    TypeGetDetailsOperatorApplyScreen: "TypeGetDetailsOperatorApplyScreen",
    TypeSetDetailsOperatorApplyScreen: "TypeSetDetailsOperatorApplyScreen",
    urlDetailsOperatorApplyScreen: BASE_URL_SN,
    urlSetDetailsOperatorApplyScreen: `/api/applyNotify`,
    DetailsOperatorApplyScreen_SERVICE_PENDING_Set: 'DetailsOperatorApplyScreen_SERVICE_PENDING_Set',
    DetailsOperatorApplyScreen_SERVICE_ERROR_Set: 'DetailsOperatorApplyScreen_SERVICE_ERROR_Set',
    DetailsOperatorApplyScreen_SERVICE_SUCCESS_Set: 'DetailsOperatorApplyScreen_SERVICE_SUCCESS_Set',
    DetailsOperatorApplyScreen_SERVICE_PENDING: 'DetailsOperatorApplyScreen_SERVICE_PENDING',
    DetailsOperatorApplyScreen_SERVICE_ERROR: 'DetailsOperatorApplyScreen_SERVICE_ERROR',
    DetailsOperatorApplyScreen_SERVICE_SUCCESS: 'DetailsOperatorApplyScreen_SERVICE_SUCCESS',
    DetailsOperatorApplyScreen_SERVICE_REFRESH: 'DetailsOperatorApplyScreen_SERVICE_REFRESH',


    //  DetailsOperatorFireApply
    TypeGetDetailsOperatorFireApplyScreen: "TypeGetDetailsOperatorFireApplyScreen",
    TypeSetDetailsOperatorFireApplyScreen: "TypeSetDetailsOperatorFireApplyScreen",
    urlDetailsOperatorFireApplyScreen: BASE_URL_SN,
    urlSetDetailsOperatorFireApplyScreen: `/api/applyNotify`,
    DetailsOperatorFireApplyScreen_SERVICE_PENDING_Set: 'DetailsOperatorFireApplyScreen_SERVICE_PENDING_Set',
    DetailsOperatorFireApplyScreen_SERVICE_ERROR_Set: 'DetailsOperatorFireApplyScreen_SERVICE_ERROR_Set',
    DetailsOperatorFireApplyScreen_SERVICE_SUCCESS_Set: 'DetailsOperatorFireApplyScreen_SERVICE_SUCCESS_Set',
    DetailsOperatorFireApplyScreen_SERVICE_PENDING: 'DetailsOperatorFireApplyScreen_SERVICE_PENDING',
    DetailsOperatorFireApplyScreen_SERVICE_ERROR: 'DetailsOperatorFireApplyScreen_SERVICE_ERROR',
    DetailsOperatorFireApplyScreen_SERVICE_SUCCESS: 'DetailsOperatorFireApplyScreen_SERVICE_SUCCESS',
    DetailsOperatorFireApplyScreen_SERVICE_REFRESH: 'DetailsOperatorFireApplyScreen_SERVICE_REFRESH',


//ListMyApplyScreen
    TypeGetListMyApplyScreen: "TypeGetListMyApplyScreen",
    TypeSetListMyApplyScreen: "TypeSetListMyApplyScreen",
    urlListMyApplyScreen: BASE_URL_SN,
    urlSetListMyApplyScreen: `/api/applyNotify`,
    SetListMyApplyScreen_SERVICE_PENDING: 'SetListMyApplyScreen_SERVICE_PENDING',
    SetListMyApplyScreen_SERVICE_ERROR: 'SetListMyApplyScreen_SERVICE_ERROR',
    SetListMyApplyScreen_SERVICE_SUCCESS: 'SetListMyApplyScreen_SERVICE_SUCCESS',
    ListMyApplyScreen_SERVICE_CHANGE_NOTIF: 'ListMyApplyScreen_SERVICE_CHANGE_NOTIF',
    ListMyApplyScreen_SERVICE_PENDING: 'ListMyApplyScreen_SERVICE_PENDING',
    ListMyApplyScreen_SERVICE_ERROR: 'ListMyApplyScreen_SERVICE_ERROR',
    ListMyApplyScreen_SERVICE_SUCCESS: 'ListMyApplyScreen_SERVICE_SUCCESS',
    ListMyApplyScreen_SERVICE_REFRESH: 'ListMyApplyScreen_SERVICE_REFRESH',
    ListMyApplyScreen_SERVICE_END: 'ListMyApplyScreen_SERVICE_END',
    ListMyApplyScreen_SERVICE_Empty: 'ListMyApplyScreen_SERVICE_Empty',
    ListMyApplyScreen_SERVICE_ADD_FIRST_DATA: 'ListMyApplyScreen_SERVICE_ADD_FIRST_DATA',
    ListMyApplyScreen_SERVICE_AddSubList: 'ListMyApplyScreen_SERVICE_AddSubList',

//ListMyApplyOperationScreen
    TypeGetListMyApplyOperationScreen: "TypeGetListMyApplyOperationScreen",
    TypeSetListMyApplyOperationScreen: "TypeSetListMyApplyOperationScreen",
    TypeGetListMyApplyOperationOperationScreen: "TypeGetListMyApplyOperationOperationScreen",
    TypeSetListMyApplyOperationOperationScreen: "TypeSetListMyApplyOperationOperationScreen",
    urlListMyApplyOperationScreen: BASE_URL_SN,
    urlListMyApplyOperationOperationScreen: BASE_URL_SN,
    urlSetListMyApplyOperationScreen: `/api/applyNotify`,
    SetListMyApplyOperationScreen_SERVICE_PENDING: 'SetListMyApplyOperationScreen_SERVICE_PENDING',
    SetListMyApplyOperationScreen_SERVICE_ERROR: 'SetListMyApplyOperationScreen_SERVICE_ERROR',
    SetListMyApplyOperationScreen_SERVICE_SUCCESS: 'SetListMyApplyOperationScreen_SERVICE_SUCCESS',
    ListMyApplyOperationScreen_SERVICE_CHANGE_NOTIF: 'ListMyApplyOperationScreen_SERVICE_CHANGE_NOTIF',
    ListMyApplyOperationScreen_SERVICE_PENDING: 'ListMyApplyOperationScreen_SERVICE_PENDING',
    ListMyApplyOperationScreen_SERVICE_ERROR: 'ListMyApplyOperationScreen_SERVICE_ERROR',
    ListMyApplyOperationScreen_SERVICE_SUCCESS: 'ListMyApplyOperationScreen_SERVICE_SUCCESS',
    ListMyApplyOperationScreen_SERVICE_REFRESH: 'ListMyApplyOperationScreen_SERVICE_REFRESH',
    ListMyApplyOperationScreen_SERVICE_END: 'ListMyApplyOperationScreen_SERVICE_END',
    ListMyApplyOperationScreen_SERVICE_Empty: 'ListMyApplyOperationScreen_SERVICE_Empty',
    ListMyApplyOperationScreen_SERVICE_ADD_FIRST_DATA: 'ListMyApplyOperationScreen_SERVICE_ADD_FIRST_DATA',
    ListMyApplyOperationScreen_SERVICE_AddSubList: 'ListMyApplyOperationScreen_SERVICE_AddSubList',

//ListListOperatorApplyScreen
    TypeGetListOperatorApplyScreen: "TypeGetListOperatorApplyScreen",
    TypeSetListOperatorApplyScreen: "TypeSetListOperatorApplyScreen",
    urlListOperatorApplyScreen: BASE_URL_SN,
    urlSetListOperatorApplyScreen: `/api/applyNotify`,
    SetListOperatorApplyScreen_SERVICE_PENDING: 'SetListOperatorApplyScreen_SERVICE_PENDING',
    SetListOperatorApplyScreen_SERVICE_ERROR: 'SetListOperatorApplyScreen_SERVICE_ERROR',
    SetListOperatorApplyScreen_SERVICE_SUCCESS: 'SetListOperatorApplyScreen_SERVICE_SUCCESS',
    ListOperatorApplyScreen_SERVICE_CHANGE_NOTIF: 'ListOperatorApplyScreen_SERVICE_CHANGE_NOTIF',
    ListOperatorApplyScreen_SERVICE_PENDING: 'ListOperatorApplyScreen_SERVICE_PENDING',
    ListOperatorApplyScreen_SERVICE_ERROR: 'ListOperatorApplyScreen_SERVICE_ERROR',
    ListOperatorApplyScreen_SERVICE_SUCCESS: 'ListOperatorApplyScreen_SERVICE_SUCCESS',
    ListOperatorApplyScreen_SERVICE_REFRESH: 'ListOperatorApplyScreen_SERVICE_REFRESH',
    ListOperatorApplyScreen_SERVICE_END: 'ListOperatorApplyScreen_SERVICE_END',
    ListOperatorApplyScreen_SERVICE_Empty: 'ListOperatorApplyScreen_SERVICE_Empty',
    ListOperatorApplyScreen_SERVICE_ADD_FIRST_DATA: 'ListOperatorApplyScreen_SERVICE_ADD_FIRST_DATA',
    ListOperatorApplyScreen_SERVICE_AddSubList: 'ListOperatorApplyScreen_SERVICE_AddSubList',
    ListOperatorApplyScreen_SERVICE_LIST_FILTER: 'ListOperatorApplyScreen_SERVICE_LIST_FILTER',
    ListOperatorApplyScreen_SERVICE_LIST_Send: 'ListOperatorApplyScreen_SERVICE_LIST_Send',
    ListOperatorApplyScreen_SERVICE_ADD_COMMENT: 'ListOperatorApplyScreen_SERVICE_ADD_COMMENT',

//ListMessageChatScreen
    TypeGetListMessageChatScreen: "TypeGetListMessageChatScreen",
    TypeSetListMessageChatScreen: "TypeSetListMessageChatScreen",
    urlListMessageChatScreen: BASE_URL_SN,
    urlSetListMessageChatScreen: `/api/applyNotify`,
    SetListMessageChatScreen_SERVICE_PENDING: 'SetListMessageChatScreen_SERVICE_PENDING',
    SetListMessageChatScreen_SERVICE_ERROR: 'SetListMessageChatScreen_SERVICE_ERROR',
    SetListMessageChatScreen_SERVICE_SUCCESS: 'SetListMessageChatScreen_SERVICE_SUCCESS',
    ListMessageChatScreen_SERVICE_CHANGE_NOTIF: 'ListMessageChatScreen_SERVICE_CHANGE_NOTIF',
    ListMessageChatScreen_SERVICE_PENDING: 'ListMessageChatScreen_SERVICE_PENDING',
    ListMessageChatScreen_SERVICE_ERROR: 'ListMessageChatScreen_SERVICE_ERROR',
    ListMessageChatScreen_SERVICE_SUCCESS: 'ListMessageChatScreen_SERVICE_SUCCESS',
    ListMessageChatScreen_SERVICE_REFRESH: 'ListMessageChatScreen_SERVICE_REFRESH',
    ListMessageChatScreen_SERVICE_END: 'ListMessageChatScreen_SERVICE_END',
    ListMessageChatScreen_SERVICE_Empty: 'ListMessageChatScreen_SERVICE_Empty',
    ListMessageChatScreen_SERVICE_ADD_FIRST_DATA: 'ListMessageChatScreen_SERVICE_ADD_FIRST_DATA',
    ListMessageChatScreen_SERVICE_AddSubList: 'ListMessageChatScreen_SERVICE_AddSubList',
    ListMessageChatScreen_SERVICE_LIST_FILTER: 'ListMessageChatScreen_SERVICE_LIST_FILTER',
    ListMessageChatScreen_SERVICE_AddMessage: 'ListMessageChatScreen_SERVICE_AddMessage',

//ListUserChatScreen
    TypeGetListUserChatScreen: "TypeGetListUserChatScreen",
    TypeSetListUserChatScreen: "TypeSetListUserChatScreen",
    urlListUserChatScreen: BASE_URL_SN,
    urlSetListUserChatScreen: `/api/applyNotify`,
    SetListUserChatScreen_SERVICE_PENDING: 'SetListUserChatScreen_SERVICE_PENDING',
    SetListUserChatScreen_SERVICE_ERROR: 'SetListUserChatScreen_SERVICE_ERROR',
    SetListUserChatScreen_SERVICE_SUCCESS: 'SetListUserChatScreen_SERVICE_SUCCESS',
    ListUserChatScreen_SERVICE_CHANGE_NOTIF: 'ListUserChatScreen_SERVICE_CHANGE_NOTIF',
    ListUserChatScreen_SERVICE_PENDING: 'ListUserChatScreen_SERVICE_PENDING',
    ListUserChatScreen_SERVICE_ERROR: 'ListUserChatScreen_SERVICE_ERROR',
    ListUserChatScreen_SERVICE_SUCCESS: 'ListUserChatScreen_SERVICE_SUCCESS',
    ListUserChatScreen_SERVICE_REFRESH: 'ListUserChatScreen_SERVICE_REFRESH',
    ListUserChatScreen_SERVICE_END: 'ListUserChatScreen_SERVICE_END',
    ListUserChatScreen_SERVICE_Empty: 'ListUserChatScreen_SERVICE_Empty',
    ListUserChatScreen_SERVICE_ADD_FIRST_DATA: 'ListUserChatScreen_SERVICE_ADD_FIRST_DATA',
    ListUserChatScreen_SERVICE_AddSubList: 'ListUserChatScreen_SERVICE_AddSubList',
    ListUserChatScreen_SERVICE_LIST_FILTER: 'ListUserChatScreen_SERVICE_LIST_FILTER',

//GalleryServiceOperationScreen
    TypeGetGalleryServiceOperationScreen: "TypeGetGalleryServiceOperationScreen",
    TypeSetGalleryServiceOperationScreen: "TypeSetGalleryServiceOperationScreen",
    urlGalleryServiceOperationScreen: BASE_URL_SN,
    urlSetGalleryServiceOperationScreen: `/api/applyNotify`,
    SetGalleryServiceOperationScreen_SERVICE_PENDING: 'SetGalleryServiceOperationScreen_SERVICE_PENDING',
    SetGalleryServiceOperationScreen_SERVICE_ERROR: 'SetGalleryServiceOperationScreen_SERVICE_ERROR',
    SetGalleryServiceOperationScreen_SERVICE_SUCCESS: 'SetGalleryServiceOperationScreen_SERVICE_SUCCESS',
    GalleryServiceOperationScreen_SERVICE_CHANGE_NOTIF: 'GalleryServiceOperationScreen_SERVICE_CHANGE_NOTIF',
    GalleryServiceOperationScreen_SERVICE_PENDING: 'GalleryServiceOperationScreen_SERVICE_PENDING',
    GalleryServiceOperationScreen_SERVICE_ERROR: 'GalleryServiceOperationScreen_SERVICE_ERROR',
    GalleryServiceOperationScreen_SERVICE_SUCCESS: 'GalleryServiceOperationScreen_SERVICE_SUCCESS',
    GalleryServiceOperationScreen_SERVICE_REFRESH: 'GalleryServiceOperationScreen_SERVICE_REFRESH',
    GalleryServiceOperationScreen_SERVICE_END: 'GalleryServiceOperationScreen_SERVICE_END',
    GalleryServiceOperationScreen_SERVICE_Empty: 'GalleryServiceOperationScreen_SERVICE_Empty',
    GalleryServiceOperationScreen_SERVICE_ADD_FIRST_DATA: 'GalleryServiceOperationScreen_SERVICE_ADD_FIRST_DATA',
    GalleryServiceOperationScreen_SERVICE_AddSubList: 'GalleryServiceOperationScreen_SERVICE_AddSubList',
    GalleryServiceOperationScreen_SERVICE_LIST_FILTER: 'ListOperatorApplyScreen_SERVICE_LIST_FILTER',
    GalleryServiceOperationScreen_SERVICE_SET_LIKE: 'GalleryServiceOperationScreen_SERVICE_SET_LIKE',
    GalleryServiceOperationScreen_SERVICE_SET_RELEASE: 'GalleryServiceOperationScreen_SERVICE_SET_RELEASE',
    GalleryServiceOperationScreen_SERVICE_SET_DISPLAY_IMAGE: 'GalleryServiceOperationScreen_SERVICE_SET_DISPLAY_IMAGE',
    GalleryServiceOperationScreen_SERVICE_SET_DISPLAY_COMMENT: 'GalleryServiceOperationScreen_SERVICE_SET_DISPLAY_COMMENT',
    GalleryServiceOperationScreen_SERVICE_SET_COMMENT: 'GalleryServiceOperationScreen_SERVICE_SET_COMMENT',
    GalleryServiceOperationScreen_SERVICE_ADD_COMMENT: 'GalleryServiceOperationScreen_SERVICE_ADD_COMMENT',
    GalleryServiceOperationScreen_SERVICE_ADD_FILE: 'GalleryServiceOperationScreen_SERVICE_ADD_FILE',


//GalleryServiceScreen
    TypeGetGalleryServiceScreen: "TypeGetGalleryServiceScreen",
    TypeSetGalleryServiceScreen: "TypeSetGalleryServiceScreen",
    urlGalleryServiceScreen: BASE_URL_SN,
    urlSetGalleryServiceScreen: `/api/applyNotify`,
    SetGalleryServiceScreen_SERVICE_PENDING: 'SetGalleryServiceScreen_SERVICE_PENDING',
    SetGalleryServiceScreen_SERVICE_ERROR: 'SetGalleryServiceScreen_SERVICE_ERROR',
    SetGalleryServiceScreen_SERVICE_SUCCESS: 'SetGalleryServiceScreen_SERVICE_SUCCESS',
    GalleryServiceScreen_SERVICE_CHANGE_NOTIF: 'GalleryServiceScreen_SERVICE_CHANGE_NOTIF',
    GalleryServiceScreen_SERVICE_PENDING: 'GalleryServiceScreen_SERVICE_PENDING',
    GalleryServiceScreen_SERVICE_ERROR: 'GalleryServiceScreen_SERVICE_ERROR',
    GalleryServiceScreen_SERVICE_SUCCESS: 'GalleryServiceScreen_SERVICE_SUCCESS',
    GalleryServiceScreen_SERVICE_REFRESH: 'GalleryServiceScreen_SERVICE_REFRESH',
    GalleryServiceScreen_SERVICE_END: 'GalleryServiceScreen_SERVICE_END',
    GalleryServiceScreen_SERVICE_Empty: 'GalleryServiceScreen_SERVICE_Empty',
    GalleryServiceScreen_SERVICE_ADD_FIRST_DATA: 'GalleryServiceScreen_SERVICE_ADD_FIRST_DATA',
    GalleryServiceScreen_SERVICE_AddSubList: 'GalleryServiceScreen_SERVICE_AddSubList',
    GalleryServiceScreen_SERVICE_LIST_FILTER: 'ListOperatorApplyScreen_SERVICE_LIST_FILTER',
    GalleryServiceScreen_SERVICE_SET_LIKE: 'GalleryServiceScreen_SERVICE_SET_LIKE',
    GalleryServiceScreen_SERVICE_SET_RELEASE: 'GalleryServiceScreen_SERVICE_SET_RELEASE',
    GalleryServiceScreen_SERVICE_SET_DISPLAY_IMAGE: 'GalleryServiceScreen_SERVICE_SET_DISPLAY_IMAGE',
    GalleryServiceScreen_SERVICE_SET_DISPLAY_COMMENT: 'GalleryServiceScreen_SERVICE_SET_DISPLAY_COMMENT',
    GalleryServiceScreen_SERVICE_SET_COMMENT: 'GalleryServiceScreen_SERVICE_SET_COMMENT',
    GalleryServiceScreen_SERVICE_ADD_FILE: 'GalleryServiceScreen_SERVICE_ADD_FILE',


//ListOperatorFireApplyScreen
    TypeGetListOperatorFireApplyScreen: "TypeGetListOperatorFireApplyScreen",
    TypeSetListOperatorFireApplyScreen: "TypeSetListOperatorFireApplyScreen",
    urlListOperatorFireApplyScreen: BASE_URL_SN,
    urlSetListOperatorFireApplyScreen: `/api/applyNotify`,
    SetListOperatorFireApplyScreen_SERVICE_PENDING: 'SetListOperatorFireApplyScreen_SERVICE_PENDING',
    SetListOperatorFireApplyScreen_SERVICE_ERROR: 'SetListOperatorFireApplyScreen_SERVICE_ERROR',
    SetListOperatorFireApplyScreen_SERVICE_SUCCESS: 'SetListOperatorFireApplyScreen_SERVICE_SUCCESS',
    ListOperatorFireApplyScreen_SERVICE_CHANGE_NOTIF: 'ListOperatorFireApplyScreen_SERVICE_CHANGE_NOTIF',
    ListOperatorFireApplyScreen_SERVICE_PENDING: 'ListOperatorFireApplyScreen_SERVICE_PENDING',
    ListOperatorFireApplyScreen_SERVICE_ERROR: 'ListOperatorFireApplyScreen_SERVICE_ERROR',
    ListOperatorFireApplyScreen_SERVICE_SUCCESS: 'ListOperatorFireApplyScreen_SERVICE_SUCCESS',
    ListOperatorFireApplyScreen_SERVICE_REFRESH: 'ListOperatorFireApplyScreen_SERVICE_REFRESH',
    ListOperatorFireApplyScreen_SERVICE_END: 'ListOperatorFireApplyScreen_SERVICE_END',
    ListOperatorFireApplyScreen_SERVICE_Empty: 'ListOperatorFireApplyScreen_SERVICE_Empty',
    ListOperatorFireApplyScreen_SERVICE_ADD_FIRST_DATA: 'ListOperatorFireApplyScreen_SERVICE_ADD_FIRST_DATA',
    ListOperatorFireApplyScreen_SERVICE_AddSubList: 'ListOperatorFireApplyScreen_SERVICE_AddSubList',
    ListOperatorFireApplyScreen_SERVICE_LIST_FILTER: 'ListOperatorFireApplyScreen_SERVICE_LIST_FILTER',
    ListOperatorFireApplyScreen_SERVICE_CHANGE_STATE: 'ListOperatorFireApplyScreen_SERVICE_CHANGE_STATE',


//ListFormScreen
    TypeGetListFormApplyScreen: "TypeGetListFormApplyScreen",
    TypeSetListFormApplyScreen: "TypeSetListFormApplyScreen",
    urlListFormApplyScreen: BASE_URL_SN,
    urlSetListFormApplyScreen: `/api/applyNotify`,
    SetListFormApplyScreen_SERVICE_PENDING: 'SetListFormApplyScreen_SERVICE_PENDING',
    SetListFormApplyScreen_SERVICE_ERROR: 'SetListFormApplyScreen_SERVICE_ERROR',
    SetListFormApplyScreen_SERVICE_SUCCESS: 'SetListFormApplyScreen_SERVICE_SUCCESS',
    ListFormApplyScreen_SERVICE_CHANGE_NOTIF: 'ListFormApplyScreen_SERVICE_CHANGE_NOTIF',
    ListFormApplyScreen_SERVICE_PENDING: 'ListFormApplyScreen_SERVICE_PENDING',
    ListFormApplyScreen_SERVICE_ERROR: 'ListFormApplyScreen_SERVICE_ERROR',
    ListFormApplyScreen_SERVICE_SUCCESS: 'ListFormApplyScreen_SERVICE_SUCCESS',
    ListFormApplyScreen_SERVICE_REFRESH: 'ListFormApplyScreen_SERVICE_REFRESH',
    ListFormApplyScreen_SERVICE_END: 'ListFormApplyScreen_SERVICE_END',
    ListFormApplyScreen_SERVICE_Empty: 'ListFormApplyScreen_SERVICE_Empty',
    ListFormApplyScreen_SERVICE_ADD_FIRST_DATA: 'ListFormApplyScreen_SERVICE_ADD_FIRST_DATA',
    ListFormApplyScreen_SERVICE_AddSubList: 'ListFormApplyScreen_SERVICE_AddSubList',
    ListFormApplyScreen_SERVICE_LIST_FILTER: 'ListFormApplyScreen_SERVICE_LIST_FILTER',


    //  DetailsRequestScreen
    TypeGetDetailsRequestScreen: 'TypeGetDetailsRequestScreen',
    TypeSetDetailsRequestScreen: 'TypeSetDetailsRequestScreen',
    DetailsRequestScreen_SERVICE_PENDING_Set: 'DetailsRequestScreen_SERVICE_PENDING_Set',
    DetailsRequestScreen_SERVICE_ERROR_Set: 'DetailsRequestScreen_SERVICE_ERROR_Set',
    DetailsRequestScreen_SERVICE_SUCCESS_Set: 'DetailsRequestScreen_SERVICE_SUCCESS_Set',
    DetailsRequestScreen_SERVICE_PENDING: 'DetailsRequestScreen_SERVICE_PENDING',
    DetailsRequestScreen_SERVICE_ERROR: 'DetailsRequestScreen_SERVICE_ERROR',
    DetailsRequestScreen_SERVICE_SUCCESS: 'DetailsRequestScreen_SERVICE_SUCCESS',
    DetailsRequestScreen_SERVICE_REFRESH: 'DetailsRequestScreen_SERVICE_REFRESH',

    //  ExpertRegistrationMahaleMaScreen
    TypeGetExpertRegistrationMahaleMaScreen: 'TypeGetExpertRegistrationMahaleMaScreen',
    TypeSetExpertRegistrationMahaleMaScreen: 'TypeSetExpertRegistrationMahaleMaScreen',
    ExpertRegistrationMahaleMaScreen_SERVICE_PENDING_Set: 'ExpertRegistrationMahaleMaScreen_SERVICE_PENDING_Set',
    ExpertRegistrationMahaleMaScreen_SERVICE_ERROR_Set: 'ExpertRegistrationMahaleMaScreen_SERVICE_ERROR_Set',
    ExpertRegistrationMahaleMaScreen_SERVICE_SUCCESS_Set: 'ExpertRegistrationMahaleMaScreen_SERVICE_SUCCESS_Set',
    ExpertRegistrationMahaleMaScreen_SERVICE_PENDING: 'ExpertRegistrationMahaleMaScreen_SERVICE_PENDING',
    ExpertRegistrationMahaleMaScreen_SERVICE_ERROR: 'ExpertRegistrationMahaleMaScreen_SERVICE_ERROR',
    ExpertRegistrationMahaleMaScreen_SERVICE_SUCCESS: 'ExpertRegistrationMahaleMaScreen_SERVICE_SUCCESS',
    ExpertRegistrationMahaleMaScreen_SERVICE_REFRESH: 'ExpertRegistrationMahaleMaScreen_SERVICE_REFRESH',

    //  ExpertRegistrationScreen
    TypeGetExpertRegistrationScreen: 'TypeGetExpertRegistrationScreen',
    TypeSetExpertRegistrationScreen: 'TypeSetExpertRegistrationScreen',
    ExpertRegistrationScreen_SERVICE_PENDING_Set: 'ExpertRegistrationScreen_SERVICE_PENDING_Set',
    ExpertRegistrationScreen_SERVICE_ERROR_Set: 'ExpertRegistrationScreen_SERVICE_ERROR_Set',
    ExpertRegistrationScreen_SERVICE_SUCCESS_Set: 'ExpertRegistrationScreen_SERVICE_SUCCESS_Set',
    ExpertRegistrationScreen_SERVICE_PENDING: 'ExpertRegistrationScreen_SERVICE_PENDING',
    ExpertRegistrationScreen_SERVICE_ERROR: 'ExpertRegistrationScreen_SERVICE_ERROR',
    ExpertRegistrationScreen_SERVICE_SUCCESS: 'ExpertRegistrationScreen_SERVICE_SUCCESS',
    ExpertRegistrationScreen_SERVICE_REFRESH: 'ExpertRegistrationScreen_SERVICE_REFRESH',


    //ListReportMahalehMaScreen
    TypeGetListReportMahalehMaScreen: "TypeGetListReportMahalehMaScreen",
    TypeSetListReportMahalehMaScreen: "TypeSetListReportMahalehMaScreen",
    urlListReportMahalehMaScreen: BASE_URL_SN,
    urlSetListReportMahalehMaScreen: `/api/applyNotify`,
    SetListReportMahalehMaScreen_SERVICE_PENDING: 'SetListReportMahalehMaScreen_SERVICE_PENDING',
    SetListReportMahalehMaScreen_SERVICE_ERROR: 'SetListReportMahalehMaScreen_SERVICE_ERROR',
    SetListReportMahalehMaScreen_SERVICE_SUCCESS: 'SetListReportMahalehMaScreen_SERVICE_SUCCESS',
    ListReportMahalehMaScreen_SERVICE_CHANGE_NOTIF: 'ListReportMahalehMaScreen_SERVICE_CHANGE_NOTIF',
    ListReportMahalehMaScreen_SERVICE_PENDING: 'ListReportMahalehMaScreen_SERVICE_PENDING',
    ListReportMahalehMaScreen_SERVICE_ERROR: 'ListReportMahalehMaScreen_SERVICE_ERROR',
    ListReportMahalehMaScreen_SERVICE_SUCCESS: 'ListReportMahalehMaScreen_SERVICE_SUCCESS',
    ListReportMahalehMaScreen_SERVICE_REFRESH: 'ListReportMahalehMaScreen_SERVICE_REFRESH',
    ListReportMahalehMaScreen_SERVICE_END: 'ListReportMahalehMaScreen_SERVICE_END',
    ListReportMahalehMaScreen_SERVICE_Empty: 'ListReportMahalehMaScreen_SERVICE_Empty',
    ListReportMahalehMaScreen_SERVICE_ADD_FIRST_DATA: 'ListReportMahalehMaScreen_SERVICE_ADD_FIRST_DATA',
    ListReportMahalehMaScreen_SERVICE_AddSubList: 'ListReportMahalehMaScreen_SERVICE_AddSubList',
    ListReportMahalehMaScreen_SERVICE_LIST_FILTER: 'ListReportMahalehMaScreen_SERVICE_LIST_FILTER',

    //ListReportExitEnterMahalehMaScreen
    TypeGetListReportExitEnterMahalehMaScreen: "TypeGetListReportExitEnterMahalehMaScreen",
    TypeSetListReportExitEnterMahalehMaScreen: "TypeSetListReportExitEnterMahalehMaScreen",
    urlListReportExitEnterMahalehMaScreen: BASE_URL_SN,
    urlSetListReportExitEnterMahalehMaScreen: `/api/applyNotify`,
    SetListReportExitEnterMahalehMaScreen_SERVICE_PENDING: 'SetListReportExitEnterMahalehMaScreen_SERVICE_PENDING',
    SetListReportExitEnterMahalehMaScreen_SERVICE_ERROR: 'SetListReportExitEnterMahalehMaScreen_SERVICE_ERROR',
    SetListReportExitEnterMahalehMaScreen_SERVICE_SUCCESS: 'SetListReportExitEnterMahalehMaScreen_SERVICE_SUCCESS',
    ListReportExitEnterMahalehMaScreen_SERVICE_CHANGE_NOTIF: 'ListReportExitEnterMahalehMaScreen_SERVICE_CHANGE_NOTIF',
    ListReportExitEnterMahalehMaScreen_SERVICE_PENDING: 'ListReportExitEnterMahalehMaScreen_SERVICE_PENDING',
    ListReportExitEnterMahalehMaScreen_SERVICE_ERROR: 'ListReportExitEnterMahalehMaScreen_SERVICE_ERROR',
    ListReportExitEnterMahalehMaScreen_SERVICE_SUCCESS: 'ListReportExitEnterMahalehMaScreen_SERVICE_SUCCESS',
    ListReportExitEnterMahalehMaScreen_SERVICE_REFRESH: 'ListReportExitEnterMahalehMaScreen_SERVICE_REFRESH',
    ListReportExitEnterMahalehMaScreen_SERVICE_END: 'ListReportExitEnterMahalehMaScreen_SERVICE_END',
    ListReportExitEnterMahalehMaScreen_SERVICE_Empty: 'ListReportExitEnterMahalehMaScreen_SERVICE_Empty',
    ListReportExitEnterMahalehMaScreen_SERVICE_ADD_FIRST_DATA: 'ListReportExitEnterMahalehMaScreen_SERVICE_ADD_FIRST_DATA',
    ListReportExitEnterMahalehMaScreen_SERVICE_AddSubList: 'ListReportExitEnterMahalehMaScreen_SERVICE_AddSubList',
    ListReportExitEnterMahalehMaScreen_SERVICE_LIST_FILTER: 'ListReportExitEnterMahalehMaScreen_SERVICE_LIST_FILTER',

//ListMyManInjamScreen
    TypeGetListMyManInjamScreen: "TypeGetListMyManInjamScreen",
    TypeSetListMyManInjamScreen: "TypeSetListMyManInjamScreen",
    urlListMyManInjamScreen: BASE_URL_SN,
    urlSetListMyManInjamScreen: `/api/applyNotify`,
    SetListMyManInjamScreen_SERVICE_PENDING: 'SetListMyManInjamScreen_SERVICE_PENDING',
    SetListMyManInjamScreen_SERVICE_ERROR: 'SetListMyManInjamScreen_SERVICE_ERROR',
    SetListMyManInjamScreen_SERVICE_SUCCESS: 'SetListMyManInjamScreen_SERVICE_SUCCESS',
    ListMyManInjamScreen_SERVICE_CHANGE_NOTIF: 'ListMyManInjamScreen_SERVICE_CHANGE_NOTIF',
    ListMyManInjamScreen_SERVICE_PENDING: 'ListMyManInjamScreen_SERVICE_PENDING',
    ListMyManInjamScreen_SERVICE_ERROR: 'ListMyManInjamScreen_SERVICE_ERROR',
    ListMyManInjamScreen_SERVICE_SUCCESS: 'ListMyManInjamScreen_SERVICE_SUCCESS',
    ListMyManInjamScreen_SERVICE_REFRESH: 'ListMyManInjamScreen_SERVICE_REFRESH',
    ListMyManInjamScreen_SERVICE_END: 'ListMyManInjamScreen_SERVICE_END',
    ListMyManInjamScreen_SERVICE_Empty: 'ListMyManInjamScreen_SERVICE_Empty',
    ListMyManInjamScreen_SERVICE_ADD_FIRST_DATA: 'ListMyManInjamScreen_SERVICE_ADD_FIRST_DATA',
    ListMyManInjamScreen_SERVICE_AddSubList: 'ListMyManInjamScreen_SERVICE_AddSubList',


    //  DetailsManInjamScreen
    TypeGetDetailsManInjamScreen: 'TypeGetDetailsManInjamScreen',
    TypeSetDetailsManInjamScreen: 'TypeSetDetailsManInjamScreen',
    DetailsManInjamScreen_SERVICE_PENDING_Set: 'DetailsManInjamScreen_SERVICE_PENDING_Set',
    DetailsManInjamScreen_SERVICE_ERROR_Set: 'DetailsManInjamScreen_SERVICE_ERROR_Set',
    DetailsManInjamScreen_SERVICE_SUCCESS_Set: 'DetailsManInjamScreen_SERVICE_SUCCESS_Set',
    DetailsManInjamScreen_SERVICE_PENDING: 'DetailsManInjamScreen_SERVICE_PENDING',
    DetailsManInjamScreen_SERVICE_ERROR: 'DetailsManInjamScreen_SERVICE_ERROR',
    DetailsManInjamScreen_SERVICE_SUCCESS: 'DetailsManInjamScreen_SERVICE_SUCCESS',
    DetailsManInjamScreen_SERVICE_REFRESH: 'DetailsManInjamScreen_SERVICE_REFRESH',


//ListDeadScreen
    TypeGetListDeadScreen: "TypeGetListDeadScreen",
    TypeSetListDeadScreen: "TypeSetListDeadScreen",
    urlListDeadScreen: BASE_URL_SN,
    urlSetListDeadScreen: `/api/applyNotify`,
    SetListDeadScreen_SERVICE_PENDING: 'SetListDeadScreen_SERVICE_PENDING',
    SetListDeadScreen_SERVICE_ERROR: 'SetListDeadScreen_SERVICE_ERROR',
    SetListDeadScreen_SERVICE_SUCCESS: 'SetListDeadScreen_SERVICE_SUCCESS',
    ListDeadScreen_SERVICE_CHANGE_NOTIF: 'ListDeadScreen_SERVICE_CHANGE_NOTIF',
    ListDeadScreen_SERVICE_PENDING: 'ListDeadScreen_SERVICE_PENDING',
    ListDeadScreen_SERVICE_ERROR: 'ListDeadScreen_SERVICE_ERROR',
    ListDeadScreen_SERVICE_SUCCESS: 'ListDeadScreen_SERVICE_SUCCESS',
    ListDeadScreen_SERVICE_REFRESH: 'ListDeadScreen_SERVICE_REFRESH',
    ListDeadScreen_SERVICE_END: 'ListDeadScreen_SERVICE_END',
    ListDeadScreen_SERVICE_Empty: 'ListDeadScreen_SERVICE_Empty',
    ListDeadScreen_SERVICE_ADD_FIRST_DATA: 'ListDeadScreen_SERVICE_ADD_FIRST_DATA',
    ListDeadScreen_SERVICE_AddSubList: 'ListDeadScreen_SERVICE_AddSubList',


//ListMyRegisterComplaintsScreen
    TypeGetListMyRegisterComplaintsScreen: "TypeGetListMyRegisterComplaintsScreen",
    TypeSetListMyRegisterComplaintsScreen: "TypeSetListMyRegisterComplaintsScreen",
    urlListMyRegisterComplaintsScreen: BASE_URL_SN,
    urlSetListMyRegisterComplaintsScreen: `/api/applyNotify`,
    SetListMyRegisterComplaintsScreen_SERVICE_PENDING: 'SetListMyRegisterComplaintsScreen_SERVICE_PENDING',
    SetListMyRegisterComplaintsScreen_SERVICE_ERROR: 'SetListMyRegisterComplaintsScreen_SERVICE_ERROR',
    SetListMyRegisterComplaintsScreen_SERVICE_SUCCESS: 'SetListMyRegisterComplaintsScreen_SERVICE_SUCCESS',
    ListMyRegisterComplaintsScreen_SERVICE_CHANGE_NOTIF: 'ListMyRegisterComplaintsScreen_SERVICE_CHANGE_NOTIF',
    ListMyRegisterComplaintsScreen_SERVICE_PENDING: 'ListMyRegisterComplaintsScreen_SERVICE_PENDING',
    ListMyRegisterComplaintsScreen_SERVICE_ERROR: 'ListMyRegisterComplaintsScreen_SERVICE_ERROR',
    ListMyRegisterComplaintsScreen_SERVICE_SUCCESS: 'ListMyRegisterComplaintsScreen_SERVICE_SUCCESS',
    ListMyRegisterComplaintsScreen_SERVICE_REFRESH: 'ListMyRegisterComplaintsScreen_SERVICE_REFRESH',
    ListMyRegisterComplaintsScreen_SERVICE_END: 'ListMyRegisterComplaintsScreen_SERVICE_END',
    ListMyRegisterComplaintsScreen_SERVICE_Empty: 'ListMyRegisterComplaintsScreen_SERVICE_Empty',
    ListMyRegisterComplaintsScreen_SERVICE_ADD_FIRST_DATA: 'ListMyRegisterComplaintsScreen_SERVICE_ADD_FIRST_DATA',
    ListMyRegisterComplaintsScreen_SERVICE_AddSubList: 'ListMyRegisterComplaintsScreen_SERVICE_AddSubList',


//ListOperatorScrumReportScreen
    TypeGetListOperatorScrumReportScreen: "TypeGetListOperatorScrumReportScreen",
    TypeSetListOperatorScrumReportScreen: "TypeSetListOperatorScrumReportScreen",
    urlListOperatorScrumReportScreen: BASE_URL_SN,
    urlSetListOperatorScrumReportScreen: `/api/applyNotify`,
    SetListOperatorScrumReportScreen_SERVICE_PENDING: 'SetListOperatorScrumReportScreen_SERVICE_PENDING',
    SetListOperatorScrumReportScreen_SERVICE_ERROR: 'SetListOperatorScrumReportScreen_SERVICE_ERROR',
    SetListOperatorScrumReportScreen_SERVICE_SUCCESS: 'SetListOperatorScrumReportScreen_SERVICE_SUCCESS',
    ListOperatorScrumReportScreen_SERVICE_CHANGE_NOTIF: 'ListOperatorScrumReportScreen_SERVICE_CHANGE_NOTIF',
    ListOperatorScrumReportScreen_SERVICE_PENDING: 'ListOperatorScrumReportScreen_SERVICE_PENDING',
    ListOperatorScrumReportScreen_SERVICE_ERROR: 'ListOperatorScrumReportScreen_SERVICE_ERROR',
    ListOperatorScrumReportScreen_SERVICE_SUCCESS: 'ListOperatorScrumReportScreen_SERVICE_SUCCESS',
    ListOperatorScrumReportScreen_SERVICE_REFRESH: 'ListOperatorScrumReportScreen_SERVICE_REFRESH',
    ListOperatorScrumReportScreen_SERVICE_END: 'ListOperatorScrumReportScreen_SERVICE_END',
    ListOperatorScrumReportScreen_SERVICE_Empty: 'ListOperatorScrumReportScreen_SERVICE_Empty',
    ListOperatorScrumReportScreen_SERVICE_ADD_FIRST_DATA: 'ListOperatorScrumReportScreen_SERVICE_ADD_FIRST_DATA',
    ListOperatorScrumReportScreen_SERVICE_AddSubList: 'ListOperatorScrumReportScreen_SERVICE_AddSubList',
    ListOperatorScrumReportScreen_SERVICE_LIST_FILTER: 'ListOperatorScrumReportScreen_SERVICE_LIST_FILTER',


    //  DetailsOperatorScrumReportScreen
    TypeGetDetailsOperatorScrumReportScreen: "TypeGetDetailsOperatorScrumReportScreen",
    TypeSetDetailsOperatorScrumReportScreen: "TypeSetDetailsOperatorScrumReportScreen",
    urlDetailsOperatorScrumReportScreen: BASE_URL_SN,
    urlSetDetailsOperatorScrumReportScreen: `/api/applyNotify`,
    DetailsOperatorScrumReportScreen_SERVICE_PENDING_Set: 'DetailsOperatorScrumReportScreen_SERVICE_PENDING_Set',
    DetailsOperatorScrumReportScreen_SERVICE_ERROR_Set: 'DetailsOperatorScrumReportScreen_SERVICE_ERROR_Set',
    DetailsOperatorScrumReportScreen_SERVICE_SUCCESS_Set: 'DetailsOperatorScrumReportScreen_SERVICE_SUCCESS_Set',
    DetailsOperatorScrumReportScreen_SERVICE_PENDING: 'DetailsOperatorScrumReportScreen_SERVICE_PENDING',
    DetailsOperatorScrumReportScreen_SERVICE_ERROR: 'DetailsOperatorScrumReportScreen_SERVICE_ERROR',
    DetailsOperatorScrumReportScreen_SERVICE_SUCCESS: 'DetailsOperatorScrumReportScreen_SERVICE_SUCCESS',
    DetailsOperatorScrumReportScreen_SERVICE_REFRESH: 'DetailsOperatorScrumReportScreen_SERVICE_REFRESH',


    //  SubmitRequestOperationScrumReportScreen
    urlGetSubmitRequestOperationScrumReportScreen: '',
    TypeGetSubmitRequestOperationScrumReportScreen: 'TypeGetSubmitRequestOperationScrumReportScreen',
    TypeSetSubmitRequestOperationScrumReportScreen: 'TypeSetSubmitRequestOperationScrumReportScreen',
    SubmitRequestOperationScrumReportScreen_SERVICE_PENDING_Set: 'SubmitRequestOperationScrumReportScreen_SERVICE_PENDING_Set',
    SubmitRequestOperationScrumReportScreen_SERVICE_ERROR_Set: 'SubmitRequestOperationScrumReportScreen_SERVICE_ERROR_Set',
    SubmitRequestOperationScrumReportScreen_SERVICE_SUCCESS_Set: 'SubmitRequestOperationScrumReportScreen_SERVICE_SUCCESS_Set',
    SubmitRequestOperationScrumReportScreen_SERVICE_PENDING: 'SubmitRequestOperationScrumReportScreen_SERVICE_PENDING',
    SubmitRequestOperationScrumReportScreen_SERVICE_ERROR: 'SubmitRequestOperationScrumReportScreen_SERVICE_ERROR',
    SubmitRequestOperationScrumReportScreen_SERVICE_SUCCESS: 'SubmitRequestOperationScrumReportScreen_SERVICE_SUCCESS',
    SubmitRequestOperationScrumReportScreen_SERVICE_REFRESH: 'SubmitRequestOperationScrumReportScreen_SERVICE_REFRESH',

//ListReportTaskRequestScreen
    TypeGetListReportTaskRequestScreen: "TypeGetListReportTaskRequestScreen",
    TypeSetListReportTaskRequestScreen: "TypeSetListReportTaskRequestScreen",
    urlListReportTaskRequestScreen: BASE_URL_SN,
    urlSetListReportTaskRequestScreen: `/api/applyNotify`,
    SetListReportTaskRequestScreen_SERVICE_PENDING: 'SetListReportTaskRequestScreen_SERVICE_PENDING',
    SetListReportTaskRequestScreen_SERVICE_ERROR: 'SetListReportTaskRequestScreen_SERVICE_ERROR',
    SetListReportTaskRequestScreen_SERVICE_SUCCESS: 'SetListReportTaskRequestScreen_SERVICE_SUCCESS',
    ListReportTaskRequestScreen_SERVICE_CHANGE_NOTIF: 'ListReportTaskRequestScreen_SERVICE_CHANGE_NOTIF',
    ListReportTaskRequestScreen_SERVICE_PENDING: 'ListReportTaskRequestScreen_SERVICE_PENDING',
    ListReportTaskRequestScreen_SERVICE_ERROR: 'ListReportTaskRequestScreen_SERVICE_ERROR',
    ListReportTaskRequestScreen_SERVICE_SUCCESS: 'ListReportTaskRequestScreen_SERVICE_SUCCESS',
    ListReportTaskRequestScreen_SERVICE_REFRESH: 'ListReportTaskRequestScreen_SERVICE_REFRESH',
    ListReportTaskRequestScreen_SERVICE_END: 'ListReportTaskRequestScreen_SERVICE_END',
    ListReportTaskRequestScreen_SERVICE_Empty: 'ListReportTaskRequestScreen_SERVICE_Empty',
    ListReportTaskRequestScreen_SERVICE_ADD_FIRST_DATA: 'ListReportTaskRequestScreen_SERVICE_ADD_FIRST_DATA',
    ListReportTaskRequestScreen_SERVICE_AddSubList: 'ListReportTaskRequestScreen_SERVICE_AddSubList',
    ListReportTaskRequestScreen_SERVICE_LIST_FILTER: 'ListReportTaskRequestScreen_SERVICE_LIST_FILTER',

//ListReportArrearsScreen
    TypeGetListReportArrearsScreen: "TypeGetListReportArrearsScreen",
    TypeSetListReportArrearsScreen: "TypeSetListReportArrearsScreen",
    urlListReportArrearsScreen: BASE_URL_SN,
    urlSetListReportArrearsScreen: `/api/applyNotify`,
    SetListReportArrearsScreen_SERVICE_PENDING: 'SetListReportArrearsScreen_SERVICE_PENDING',
    SetListReportArrearsScreen_SERVICE_ERROR: 'SetListReportArrearsScreen_SERVICE_ERROR',
    SetListReportArrearsScreen_SERVICE_SUCCESS: 'SetListReportArrearsScreen_SERVICE_SUCCESS',
    ListReportArrearsScreen_SERVICE_CHANGE_NOTIF: 'ListReportArrearsScreen_SERVICE_CHANGE_NOTIF',
    ListReportArrearsScreen_SERVICE_PENDING: 'ListReportArrearsScreen_SERVICE_PENDING',
    ListReportArrearsScreen_SERVICE_ERROR: 'ListReportArrearsScreen_SERVICE_ERROR',
    ListReportArrearsScreen_SERVICE_SUCCESS: 'ListReportArrearsScreen_SERVICE_SUCCESS',
    ListReportArrearsScreen_SERVICE_REFRESH: 'ListReportArrearsScreen_SERVICE_REFRESH',
    ListReportArrearsScreen_SERVICE_END: 'ListReportArrearsScreen_SERVICE_END',
    ListReportArrearsScreen_SERVICE_Empty: 'ListReportArrearsScreen_SERVICE_Empty',
    ListReportArrearsScreen_SERVICE_ADD_FIRST_DATA: 'ListReportArrearsScreen_SERVICE_ADD_FIRST_DATA',
    ListReportArrearsScreen_SERVICE_AddSubList: 'ListReportArrearsScreen_SERVICE_AddSubList',
    ListReportArrearsScreen_SERVICE_LIST_FILTER: 'ListReportArrearsScreen_SERVICE_LIST_FILTER',

//ListReport15RequestScreen
    TypeGetListReport15RequestScreen: "TypeGetListReport15RequestScreen",
    TypeSetListReport15RequestScreen: "TypeSetListReport15RequestScreen",
    urlListReport15RequestScreen: BASE_URL_SN,
    urlSetListReport15RequestScreen: `/api/applyNotify`,
    SetListReport15RequestScreen_SERVICE_PENDING: 'SetListReport15RequestScreen_SERVICE_PENDING',
    SetListReport15RequestScreen_SERVICE_ERROR: 'SetListReport15RequestScreen_SERVICE_ERROR',
    SetListReport15RequestScreen_SERVICE_SUCCESS: 'SetListReport15RequestScreen_SERVICE_SUCCESS',
    ListReport15RequestScreen_SERVICE_CHANGE_NOTIF: 'ListReport15RequestScreen_SERVICE_CHANGE_NOTIF',
    ListReport15RequestScreen_SERVICE_PENDING: 'ListReport15RequestScreen_SERVICE_PENDING',
    ListReport15RequestScreen_SERVICE_ERROR: 'ListReport15RequestScreen_SERVICE_ERROR',
    ListReport15RequestScreen_SERVICE_SUCCESS: 'ListReport15RequestScreen_SERVICE_SUCCESS',
    ListReport15RequestScreen_SERVICE_REFRESH: 'ListReport15RequestScreen_SERVICE_REFRESH',
    ListReport15RequestScreen_SERVICE_END: 'ListReport15RequestScreen_SERVICE_END',
    ListReport15RequestScreen_SERVICE_Empty: 'ListReport15RequestScreen_SERVICE_Empty',
    ListReport15RequestScreen_SERVICE_ADD_FIRST_DATA: 'ListReport15RequestScreen_SERVICE_ADD_FIRST_DATA',
    ListReport15RequestScreen_SERVICE_AddSubList: 'ListReport15RequestScreen_SERVICE_AddSubList',
    ListReport15RequestScreen_SERVICE_LIST_FILTER: 'ListReport15RequestScreen_SERVICE_LIST_FILTER',


    //ListReportStatusRequestScreen
    TypeGetListReportStatusRequestScreen: "TypeGetListReportStatusRequestScreen",
    TypeSetListReportStatusRequestScreen: "TypeSetListReportStatusRequestScreen",
    urlListReportStatusRequestScreen: BASE_URL_SN,
    urlSetListReportStatusRequestScreen: `/api/applyNotify`,
    SetListReportStatusRequestScreen_SERVICE_PENDING: 'SetListReportStatusRequestScreen_SERVICE_PENDING',
    SetListReportStatusRequestScreen_SERVICE_ERROR: 'SetListReportStatusRequestScreen_SERVICE_ERROR',
    SetListReportStatusRequestScreen_SERVICE_SUCCESS: 'SetListReportStatusRequestScreen_SERVICE_SUCCESS',
    ListReportStatusRequestScreen_SERVICE_CHANGE_NOTIF: 'ListReportStatusRequestScreen_SERVICE_CHANGE_NOTIF',
    ListReportStatusRequestScreen_SERVICE_PENDING: 'ListReportStatusRequestScreen_SERVICE_PENDING',
    ListReportStatusRequestScreen_SERVICE_ERROR: 'ListReportStatusRequestScreen_SERVICE_ERROR',
    ListReportStatusRequestScreen_SERVICE_SUCCESS: 'ListReportStatusRequestScreen_SERVICE_SUCCESS',
    ListReportStatusRequestScreen_SERVICE_REFRESH: 'ListReportStatusRequestScreen_SERVICE_REFRESH',
    ListReportStatusRequestScreen_SERVICE_END: 'ListReportStatusRequestScreen_SERVICE_END',
    ListReportStatusRequestScreen_SERVICE_Empty: 'ListReportStatusRequestScreen_SERVICE_Empty',
    ListReportStatusRequestScreen_SERVICE_ADD_FIRST_DATA: 'ListReportStatusRequestScreen_SERVICE_ADD_FIRST_DATA',
    ListReportStatusRequestScreen_SERVICE_AddSubList: 'ListReportStatusRequestScreen_SERVICE_AddSubList',
    ListReportStatusRequestScreen_SERVICE_LIST_FILTER: 'ListReportStatusRequestScreen_SERVICE_LIST_FILTER',

    //ListReportStatusRequestScreen2
    TypeGetListReportStatusRequestScreen2: "TypeGetListReportStatusRequestScreen2",
    TypeSetListReportStatusRequestScreen2: "TypeSetListReportStatusRequestScreen2",
    urlListReportStatusRequestScreen2: BASE_URL_SN,
    urlSetListReportStatusRequestScreen2: `/api/applyNotify`,
    SetListReportStatusRequestScreen2_SERVICE_PENDING: 'SetListReportStatusRequestScreen2_SERVICE_PENDING',
    SetListReportStatusRequestScreen2_SERVICE_ERROR: 'SetListReportStatusRequestScreen2_SERVICE_ERROR',
    SetListReportStatusRequestScreen2_SERVICE_SUCCESS: 'SetListReportStatusRequestScreen2_SERVICE_SUCCESS',
    ListReportStatusRequestScreen2_SERVICE_CHANGE_NOTIF: 'ListReportStatusRequestScreen2_SERVICE_CHANGE_NOTIF',
    ListReportStatusRequestScreen2_SERVICE_PENDING: 'ListReportStatusRequestScreen2_SERVICE_PENDING',
    ListReportStatusRequestScreen2_SERVICE_ERROR: 'ListReportStatusRequestScreen2_SERVICE_ERROR',
    ListReportStatusRequestScreen2_SERVICE_SUCCESS: 'ListReportStatusRequestScreen2_SERVICE_SUCCESS',
    ListReportStatusRequestScreen2_SERVICE_REFRESH: 'ListReportStatusRequestScreen2_SERVICE_REFRESH',
    ListReportStatusRequestScreen2_SERVICE_END: 'ListReportStatusRequestScreen2_SERVICE_END',
    ListReportStatusRequestScreen2_SERVICE_Empty: 'ListReportStatusRequestScreen2_SERVICE_Empty',
    ListReportStatusRequestScreen2_SERVICE_ADD_FIRST_DATA: 'ListReportStatusRequestScreen2_SERVICE_ADD_FIRST_DATA',
    ListReportStatusRequestScreen2_SERVICE_AddSubList: 'ListReportStatusRequestScreen2_SERVICE_AddSubList',
    ListReportStatusRequestScreen2_SERVICE_LIST_FILTER: 'ListReportStatusRequestScreen2_SERVICE_LIST_FILTER',


    //ListReport15RequestScreen2
    TypeGetListReport15RequestScreen2: "TypeGetListReport15RequestScreen2",
    TypeSetListReport15RequestScreen2: "TypeSetListReport15RequestScreen2",
    urlListReport15RequestScreen2: BASE_URL_SN,
    urlSetListReport15RequestScreen2: `/api/applyNotify`,
    SetListReport15RequestScreen2_SERVICE_PENDING: 'SetListReport15RequestScreen2_SERVICE_PENDING',
    SetListReport15RequestScreen2_SERVICE_ERROR: 'SetListReport15RequestScreen2_SERVICE_ERROR',
    SetListReport15RequestScreen2_SERVICE_SUCCESS: 'SetListReport15RequestScreen2_SERVICE_SUCCESS',
    ListReport15RequestScreen2_SERVICE_CHANGE_NOTIF: 'ListReport15RequestScreen2_SERVICE_CHANGE_NOTIF',
    ListReport15RequestScreen2_SERVICE_PENDING: 'ListReport15RequestScreen2_SERVICE_PENDING',
    ListReport15RequestScreen2_SERVICE_ERROR: 'ListReport15RequestScreen2_SERVICE_ERROR',
    ListReport15RequestScreen2_SERVICE_SUCCESS: 'ListReport15RequestScreen2_SERVICE_SUCCESS',
    ListReport15RequestScreen2_SERVICE_REFRESH: 'ListReport15RequestScreen2_SERVICE_REFRESH',
    ListReport15RequestScreen2_SERVICE_END: 'ListReport15RequestScreen2_SERVICE_END',
    ListReport15RequestScreen2_SERVICE_Empty: 'ListReport15RequestScreen2_SERVICE_Empty',
    ListReport15RequestScreen2_SERVICE_ADD_FIRST_DATA: 'ListReport15RequestScreen2_SERVICE_ADD_FIRST_DATA',
    ListReport15RequestScreen2_SERVICE_AddSubList: 'ListReport15RequestScreen2_SERVICE_AddSubList',
    ListReport15RequestScreen2_SERVICE_LIST_FILTER: 'ListReport15RequestScreen2_SERVICE_LIST_FILTER',


    //satia

    //  ChangPssSatiaScreen
    SetChangPssSatiaScreen_SERVICE_PENDING: 'SetChangPssSatiaScreen_SERVICE_PENDING',
    SetChangPssSatiaScreen_SERVICE_ERROR: 'SetChangPssSatiaScreen_SERVICE_ERROR',
    SetChangPssSatiaScreen_SERVICE_SUCCESS: 'SetChangPssSatiaScreen_SERVICE_SUCCESS',
    ChangPssSatiaScreen_SERVICE_PENDING: 'ChangPssSatiaScreen_SERVICE_PENDING',
    ChangPssSatiaScreen_SERVICE_ERROR: 'ChangPssSatiaScreen_SERVICE_ERROR',
    ChangPssSatiaScreen_SERVICE_SUCCESS: 'ChangPssSatiaScreen_SERVICE_SUCCESS',
    ChangPssSatiaScreen_SERVICE_REFRESH: 'ChangPssSatiaScreen_SERVICE_REFRESH',

//AddTaskOperationSatiaScreen
    TypeGetAddTaskOperationSatiaScreen: "TypeGetAddTaskOperationSatiaScreen",
    TypeSetAddTaskOperationSatiaScreen: "TypeSetAddTaskOperationSatiaScreen",
    urlAddTaskOperationSatiaScreen: BASE_URL_SN,
    urlSetAddTaskOperationSatiaScreen: `/api/applyNotify`,
    SetAddTaskOperationSatiaScreen_SERVICE_PENDING: 'SetAddTaskOperationSatiaScreen_SERVICE_PENDING',
    SetAddTaskOperationSatiaScreen_SERVICE_ERROR: 'SetAddTaskOperationSatiaScreen_SERVICE_ERROR',
    SetAddTaskOperationSatiaScreen_SERVICE_SUCCESS: 'SetAddTaskOperationSatiaScreen_SERVICE_SUCCESS',
    AddTaskOperationSatiaScreen_SERVICE_CHANGE_NOTIF: 'AddTaskOperationSatiaScreen_SERVICE_CHANGE_NOTIF',
    AddTaskOperationSatiaScreen_SERVICE_PENDING: 'AddTaskOperationSatiaScreen_SERVICE_PENDING',
    AddTaskOperationSatiaScreen_SERVICE_ERROR: 'AddTaskOperationSatiaScreen_SERVICE_ERROR',
    AddTaskOperationSatiaScreen_SERVICE_SUCCESS: 'AddTaskOperationSatiaScreen_SERVICE_SUCCESS',
    AddTaskOperationSatiaScreen_SERVICE_REFRESH: 'AddTaskOperationSatiaScreen_SERVICE_REFRESH',
    AddTaskOperationSatiaScreen_SERVICE_END: 'AddTaskOperationSatiaScreen_SERVICE_END',
    AddTaskOperationSatiaScreen_SERVICE_Empty: 'AddTaskOperationSatiaScreen_SERVICE_Empty',
    AddTaskOperationSatiaScreen_SERVICE_ADD_FIRST_DATA: 'AddTaskOperationSatiaScreen_SERVICE_ADD_FIRST_DATA',
    AddTaskOperationSatiaScreen_SERVICE_AddSubList: 'AddTaskOperationSatiaScreen_SERVICE_AddSubList',
    AddTaskOperationSatiaScreen_SERVICE_LIST_FILTER: 'AddTaskOperationSatiaScreen_SERVICE_LIST_FILTER',


    //  DetailsTaskOperationSatiaScreen
    urlGetDetailsTaskOperationSatiaScreen: '',
    TypeGetDetailsTaskOperationSatiaScreen: 'TypeGetDetailsTaskOperationSatiaScreen',
    TypeSetDetailsTaskOperationSatiaScreen: 'TypeSetDetailsTaskOperationSatiaScreen',
    DetailsTaskOperationSatiaScreen_SERVICE_PENDING_Set: 'DetailsTaskOperationSatiaScreen_SERVICE_PENDING_Set',
    DetailsTaskOperationSatiaScreen_SERVICE_ERROR_Set: 'DetailsTaskOperationSatiaScreen_SERVICE_ERROR_Set',
    DetailsTaskOperationSatiaScreen_SERVICE_SUCCESS_Set: 'DetailsTaskOperationSatiaScreen_SERVICE_SUCCESS_Set',
    DetailsTaskOperationSatiaScreen_SERVICE_PENDING: 'DetailsTaskOperationSatiaScreen_SERVICE_PENDING',
    DetailsTaskOperationSatiaScreen_SERVICE_ERROR: 'DetailsTaskOperationSatiaScreen_SERVICE_ERROR',
    DetailsTaskOperationSatiaScreen_SERVICE_SUCCESS: 'DetailsTaskOperationSatiaScreen_SERVICE_SUCCESS',
    DetailsTaskOperationSatiaScreen_SERVICE_REFRESH: 'DetailsTaskOperationSatiaScreen_SERVICE_REFRESH',


//  TasksOperationSatiaScreen
    TypeGetTasksOperationSatiaScreen: "TypeGetTasksOperationSatiaScreen",
    TypeSetTasksOperationSatiaScreen: "TypeSetTasksOperationSatiaScreen",
    urlTasksOperationSatiaScreen: BASE_URL_SN,
    urlSetTasksOperationSatiaScreen: '/api/applyNotify',
    TasksOperationSatiaScreen_SERVICE_PENDING_Set: 'TasksOperationSatiaScreen_SERVICE_PENDING_Set',
    TasksOperationSatiaScreen_SERVICE_ERROR_Set: 'TasksOperationSatiaScreen_SERVICE_ERROR_Set',
    TasksOperationSatiaScreen_SERVICE_SUCCESS_Set: 'TasksOperationSatiaScreen_SERVICE_SUCCESS_Set',
    TasksOperationSatiaScreen_SERVICE_PENDING: 'TasksOperationSatiaScreen_SERVICE_PENDING',
    TasksOperationSatiaScreen_SERVICE_ERROR: 'TasksOperationSatiaScreen_SERVICE_ERROR',
    TasksOperationSatiaScreen_SERVICE_SUCCESS: 'TasksOperationSatiaScreen_SERVICE_SUCCESS',
    TasksOperationSatiaScreen_SERVICE_REFRESH: 'TasksOperationSatiaScreen_SERVICE_REFRESH',


//ListTaskOperationSatiaScreen
    TypeGetListTaskOperationSatiaScreen: "TypeGetListTaskOperationSatiaScreen",
    TypeSetListTaskOperationSatiaScreen: "TypeSetListTaskOperationSatiaScreen",
    urlListTaskOperationSatiaScreen: BASE_URL_SN,
    urlSetListTaskOperationSatiaScreen: '/api/applyNotify',
    SetListTaskOperationSatiaScreen_SERVICE_PENDING: 'SetListTaskOperationSatiaScreen_SERVICE_PENDING',
    SetListTaskOperationSatiaScreen_SERVICE_ERROR: 'SetListTaskOperationSatiaScreen_SERVICE_ERROR',
    SetListTaskOperationSatiaScreen_SERVICE_SUCCESS: 'SetListTaskOperationSatiaScreen_SERVICE_SUCCESS',
    ListTaskOperationSatiaScreen_SERVICE_CHANGE_NOTIF: 'ListTaskOperationSatiaScreen_SERVICE_CHANGE_NOTIF',
    ListTaskOperationSatiaScreen_SERVICE_PENDING: 'ListTaskOperationSatiaScreen_SERVICE_PENDING',
    ListTaskOperationSatiaScreen_SERVICE_ERROR: 'ListTaskOperationSatiaScreen_SERVICE_ERROR',
    ListTaskOperationSatiaScreen_SERVICE_SUCCESS: 'ListTaskOperationSatiaScreen_SERVICE_SUCCESS',
    ListTaskOperationSatiaScreen_SERVICE_REFRESH: 'ListTaskOperationSatiaScreen_SERVICE_REFRESH',
    ListTaskOperationSatiaScreen_SERVICE_END: 'ListTaskOperationSatiaScreen_SERVICE_END',
    ListTaskOperationSatiaScreen_SERVICE_Empty: 'ListTaskOperationSatiaScreen_SERVICE_Empty',
    ListTaskOperationSatiaScreen_SERVICE_ADD_FIRST_DATA: 'ListTaskOperationSatiaScreen_SERVICE_ADD_FIRST_DATA',
    ListTaskOperationSatiaScreen_SERVICE_AddSubList: 'ListTaskOperationSatiaScreen_SERVICE_AddSubList',
    ListTaskOperationSatiaScreen_SERVICE_LIST_FILTER: 'ListTaskOperationSatiaScreen_SERVICE_LIST_FILTER',

//ListTaskOperationSatiaScreen
    TypeGetListReportTaskOperationSatiaScreen: "TypeGetListReportTaskOperationSatiaScreen",
    TypeSetListReportTaskOperationSatiaScreen: "TypeSetListReportTaskOperationSatiaScreen",
    urlListReportTaskOperationSatiaScreen: BASE_URL_SN,
    urlSetListReportTaskOperationSatiaScreen: '/api/applyNotify',
    SetListReportTaskOperationSatiaScreen_SERVICE_PENDING: 'SetListReportTaskOperationSatiaScreen_SERVICE_PENDING',
    SetListReportTaskOperationSatiaScreen_SERVICE_ERROR: 'SetListReportTaskOperationSatiaScreen_SERVICE_ERROR',
    SetListReportTaskOperationSatiaScreen_SERVICE_SUCCESS: 'SetListReportTaskOperationSatiaScreen_SERVICE_SUCCESS',
    ListReportTaskOperationSatiaScreen_SERVICE_CHANGE_NOTIF: 'ListReportTaskOperationSatiaScreen_SERVICE_CHANGE_NOTIF',
    ListReportTaskOperationSatiaScreen_SERVICE_PENDING: 'ListReportTaskOperationSatiaScreen_SERVICE_PENDING',
    ListReportTaskOperationSatiaScreen_SERVICE_ERROR: 'ListReportTaskOperationSatiaScreen_SERVICE_ERROR',
    ListReportTaskOperationSatiaScreen_SERVICE_SUCCESS: 'ListReportTaskOperationSatiaScreen_SERVICE_SUCCESS',
    ListReportTaskOperationSatiaScreen_SERVICE_REFRESH: 'ListReportTaskOperationSatiaScreen_SERVICE_REFRESH',
    ListReportTaskOperationSatiaScreen_SERVICE_END: 'ListReportTaskOperationSatiaScreen_SERVICE_END',
    ListReportTaskOperationSatiaScreen_SERVICE_Empty: 'ListReportTaskOperationSatiaScreen_SERVICE_Empty',
    ListReportTaskOperationSatiaScreen_SERVICE_ADD_FIRST_DATA: 'ListReportTaskOperationSatiaScreen_SERVICE_ADD_FIRST_DATA',
    ListReportTaskOperationSatiaScreen_SERVICE_AddSubList: 'ListReportTaskOperationSatiaScreen_SERVICE_AddSubList',
    ListReportTaskOperationSatiaScreen_SERVICE_LIST_FILTER: 'ListReportTaskOperationSatiaScreen_SERVICE_LIST_FILTER',
//ListVirtualBankSatiaScreen
    TypeGetListVirtualBankSatiaScreen: "TypeGetListVirtualBankSatiaScreen",
    TypeSetListVirtualBankSatiaScreen: "TypeSetListVirtualBankSatiaScreen",
    urlListVirtualBankSatiaScreen: BASE_URL_SN,
    urlSetListVirtualBankSatiaScreen: `/api/applyNotify`,
    SetListVirtualBankSatiaScreen_SERVICE_PENDING: 'SetListVirtualBankSatiaScreen_SERVICE_PENDING',
    SetListVirtualBankSatiaScreen_SERVICE_ERROR: 'SetListVirtualBankSatiaScreen_SERVICE_ERROR',
    SetListVirtualBankSatiaScreen_SERVICE_SUCCESS: 'SetListVirtualBankSatiaScreen_SERVICE_SUCCESS',
    ListVirtualBankSatiaScreen_SERVICE_CHANGE_NOTIF: 'ListVirtualBankSatiaScreen_SERVICE_CHANGE_NOTIF',
    ListVirtualBankSatiaScreen_SERVICE_PENDING: 'ListVirtualBankSatiaScreen_SERVICE_PENDING',
    ListVirtualBankSatiaScreen_SERVICE_ERROR: 'ListVirtualBankSatiaScreen_SERVICE_ERROR',
    ListVirtualBankSatiaScreen_SERVICE_SUCCESS: 'ListVirtualBankSatiaScreen_SERVICE_SUCCESS',
    ListVirtualBankSatiaScreen_SERVICE_REFRESH: 'ListVirtualBankSatiaScreen_SERVICE_REFRESH',
    ListVirtualBankSatiaScreen_SERVICE_END: 'ListVirtualBankSatiaScreen_SERVICE_END',
    ListVirtualBankSatiaScreen_SERVICE_Empty: 'ListVirtualBankSatiaScreen_SERVICE_Empty',
    ListVirtualBankSatiaScreen_SERVICE_ADD_FIRST_DATA: 'ListVirtualBankSatiaScreen_SERVICE_ADD_FIRST_DATA',
    ListVirtualBankSatiaScreen_SERVICE_AddSubList: 'ListVirtualBankSatiaScreen_SERVICE_AddSubList',
    ListVirtualBankSatiaScreen_SERVICE_LIST_FILTER: 'ListVirtualBankSatiaScreen_SERVICE_LIST_FILTER',


//ListServiceHistorySatiaScreen
    TypeGetListServiceHistorySatiaScreen: "TypeGetListServiceHistorySatiaScreen",
    TypeSetListServiceHistorySatiaScreen: "TypeSetListServiceHistorySatiaScreen",
    urlListServiceHistorySatiaScreen: BASE_URL_SN,
    urlSetListServiceHistorySatiaScreen: `/api/applyNotify`,
    SetListServiceHistorySatiaScreen_SERVICE_PENDING: 'SetListServiceHistorySatiaScreen_SERVICE_PENDING',
    SetListServiceHistorySatiaScreen_SERVICE_ERROR: 'SetListServiceHistorySatiaScreen_SERVICE_ERROR',
    SetListServiceHistorySatiaScreen_SERVICE_SUCCESS: 'SetListServiceHistorySatiaScreen_SERVICE_SUCCESS',
    ListServiceHistorySatiaScreen_SERVICE_CHANGE_NOTIF: 'ListServiceHistorySatiaScreen_SERVICE_CHANGE_NOTIF',
    ListServiceHistorySatiaScreen_SERVICE_PENDING: 'ListServiceHistorySatiaScreen_SERVICE_PENDING',
    ListServiceHistorySatiaScreen_SERVICE_ERROR: 'ListServiceHistorySatiaScreen_SERVICE_ERROR',
    ListServiceHistorySatiaScreen_SERVICE_SUCCESS: 'ListServiceHistorySatiaScreen_SERVICE_SUCCESS',
    ListServiceHistorySatiaScreen_SERVICE_REFRESH: 'ListServiceHistorySatiaScreen_SERVICE_REFRESH',
    ListServiceHistorySatiaScreen_SERVICE_END: 'ListServiceHistorySatiaScreen_SERVICE_END',
    ListServiceHistorySatiaScreen_SERVICE_Empty: 'ListServiceHistorySatiaScreen_SERVICE_Empty',
    ListServiceHistorySatiaScreen_SERVICE_ADD_FIRST_DATA: 'ListServiceHistorySatiaScreen_SERVICE_ADD_FIRST_DATA',
    ListServiceHistorySatiaScreen_SERVICE_AddSubList: 'ListServiceHistorySatiaScreen_SERVICE_AddSubList',
    ListServiceHistorySatiaScreen_SERVICE_LIST_FILTER: 'ListServiceHistorySatiaScreen_SERVICE_LIST_FILTER',


//ListOnlineChargingHistorySatiaScreen
    TypeGetListOnlineChargingHistorySatiaScreen: "TypeGetListOnlineChargingHistorySatiaScreen",
    TypeSetListOnlineChargingHistorySatiaScreen: "TypeSetListOnlineChargingHistorySatiaScreen",
    urlListOnlineChargingHistorySatiaScreen: BASE_URL_SN,
    urlSetListOnlineChargingHistorySatiaScreen: `/api/applyNotify`,
    SetListOnlineChargingHistorySatiaScreen_SERVICE_PENDING: 'SetListOnlineChargingHistorySatiaScreen_SERVICE_PENDING',
    SetListOnlineChargingHistorySatiaScreen_SERVICE_ERROR: 'SetListOnlineChargingHistorySatiaScreen_SERVICE_ERROR',
    SetListOnlineChargingHistorySatiaScreen_SERVICE_SUCCESS: 'SetListOnlineChargingHistorySatiaScreen_SERVICE_SUCCESS',
    ListOnlineChargingHistorySatiaScreen_SERVICE_CHANGE_NOTIF: 'ListOnlineChargingHistorySatiaScreen_SERVICE_CHANGE_NOTIF',
    ListOnlineChargingHistorySatiaScreen_SERVICE_PENDING: 'ListOnlineChargingHistorySatiaScreen_SERVICE_PENDING',
    ListOnlineChargingHistorySatiaScreen_SERVICE_ERROR: 'ListOnlineChargingHistorySatiaScreen_SERVICE_ERROR',
    ListOnlineChargingHistorySatiaScreen_SERVICE_SUCCESS: 'ListOnlineChargingHistorySatiaScreen_SERVICE_SUCCESS',
    ListOnlineChargingHistorySatiaScreen_SERVICE_REFRESH: 'ListOnlineChargingHistorySatiaScreen_SERVICE_REFRESH',
    ListOnlineChargingHistorySatiaScreen_SERVICE_END: 'ListOnlineChargingHistorySatiaScreen_SERVICE_END',
    ListOnlineChargingHistorySatiaScreen_SERVICE_Empty: 'ListOnlineChargingHistorySatiaScreen_SERVICE_Empty',
    ListOnlineChargingHistorySatiaScreen_SERVICE_ADD_FIRST_DATA: 'ListOnlineChargingHistorySatiaScreen_SERVICE_ADD_FIRST_DATA',
    ListOnlineChargingHistorySatiaScreen_SERVICE_AddSubList: 'ListOnlineChargingHistorySatiaScreen_SERVICE_AddSubList',
    ListOnlineChargingHistorySatiaScreen_SERVICE_LIST_FILTER: 'ListOnlineChargingHistorySatiaScreen_SERVICE_LIST_FILTER',


//HistoryTelephoneLineStatusSatiaScreen
    TypeGetHistoryTelephoneLineStatusSatiaScreen: "TypeGetHistoryTelephoneLineStatusSatiaScreen",
    TypeSetHistoryTelephoneLineStatusSatiaScreen: "TypeSetHistoryTelephoneLineStatusSatiaScreen",
    urlHistoryTelephoneLineStatusSatiaScreen: BASE_URL_SN,
    urlSetHistoryTelephoneLineStatusSatiaScreen: `/api/applyNotify`,
    SetHistoryTelephoneLineStatusSatiaScreen_SERVICE_PENDING: 'SetHistoryTelephoneLineStatusSatiaScreen_SERVICE_PENDING',
    SetHistoryTelephoneLineStatusSatiaScreen_SERVICE_ERROR: 'SetHistoryTelephoneLineStatusSatiaScreen_SERVICE_ERROR',
    SetHistoryTelephoneLineStatusSatiaScreen_SERVICE_SUCCESS: 'SetHistoryTelephoneLineStatusSatiaScreen_SERVICE_SUCCESS',
    HistoryTelephoneLineStatusSatiaScreen_SERVICE_CHANGE_NOTIF: 'HistoryTelephoneLineStatusSatiaScreen_SERVICE_CHANGE_NOTIF',
    HistoryTelephoneLineStatusSatiaScreen_SERVICE_PENDING: 'HistoryTelephoneLineStatusSatiaScreen_SERVICE_PENDING',
    HistoryTelephoneLineStatusSatiaScreen_SERVICE_ERROR: 'HistoryTelephoneLineStatusSatiaScreen_SERVICE_ERROR',
    HistoryTelephoneLineStatusSatiaScreen_SERVICE_SUCCESS: 'HistoryTelephoneLineStatusSatiaScreen_SERVICE_SUCCESS',
    HistoryTelephoneLineStatusSatiaScreen_SERVICE_REFRESH: 'HistoryTelephoneLineStatusSatiaScreen_SERVICE_REFRESH',
    HistoryTelephoneLineStatusSatiaScreen_SERVICE_END: 'HistoryTelephoneLineStatusSatiaScreen_SERVICE_END',
    HistoryTelephoneLineStatusSatiaScreen_SERVICE_Empty: 'HistoryTelephoneLineStatusSatiaScreen_SERVICE_Empty',
    HistoryTelephoneLineStatusSatiaScreen_SERVICE_ADD_FIRST_DATA: 'HistoryTelephoneLineStatusSatiaScreen_SERVICE_ADD_FIRST_DATA',
    HistoryTelephoneLineStatusSatiaScreen_SERVICE_AddSubList: 'HistoryTelephoneLineStatusSatiaScreen_SERVICE_AddSubList',
    HistoryTelephoneLineStatusSatiaScreen_SERVICE_LIST_FILTER: 'HistoryTelephoneLineStatusSatiaScreen_SERVICE_LIST_FILTER',


    //ServiceHistorySatiaScreen
    TypeGetServiceHistorySatiaScreen: "TypeGetServiceHistorySatiaScreen",
    TypeSetServiceHistorySatiaScreen: "TypeSetServiceHistorySatiaScreen",
    urlServiceHistorySatiaScreen: BASE_URL_SN,
    urlSetServiceHistorySatiaScreen: `/api/applyNotify`,
    SetServiceHistorySatiaScreen_SERVICE_PENDING: 'SetServiceHistorySatiaScreen_SERVICE_PENDING',
    SetServiceHistorySatiaScreen_SERVICE_ERROR: 'SetServiceHistorySatiaScreen_SERVICE_ERROR',
    SetServiceHistorySatiaScreen_SERVICE_SUCCESS: 'SetServiceHistorySatiaScreen_SERVICE_SUCCESS',
    ServiceHistorySatiaScreen_SERVICE_CHANGE_NOTIF: 'ServiceHistorySatiaScreen_SERVICE_CHANGE_NOTIF',
    ServiceHistorySatiaScreen_SERVICE_PENDING: 'ServiceHistorySatiaScreen_SERVICE_PENDING',
    ServiceHistorySatiaScreen_SERVICE_ERROR: 'ServiceHistorySatiaScreen_SERVICE_ERROR',
    ServiceHistorySatiaScreen_SERVICE_SUCCESS: 'ServiceHistorySatiaScreen_SERVICE_SUCCESS',
    ServiceHistorySatiaScreen_SERVICE_REFRESH: 'ServiceHistorySatiaScreen_SERVICE_REFRESH',
    ServiceHistorySatiaScreen_SERVICE_END: 'ServiceHistorySatiaScreen_SERVICE_END',
    ServiceHistorySatiaScreen_SERVICE_Empty: 'ServiceHistorySatiaScreen_SERVICE_Empty',
    ServiceHistorySatiaScreen_SERVICE_ADD_FIRST_DATA: 'ServiceHistorySatiaScreen_SERVICE_ADD_FIRST_DATA',
    ServiceHistorySatiaScreen_SERVICE_AddSubList: 'ServiceHistorySatiaScreen_SERVICE_AddSubList',
    ServiceHistorySatiaScreen_SERVICE_LIST_FILTER: 'ServiceHistorySatiaScreen_SERVICE_LIST_FILTER',


//ListHistoryTelephoneLineStatusSatiaScreen
    TypeGetListHistoryTelephoneLineStatusSatiaScreen: "TypeGetListHistoryTelephoneLineStatusSatiaScreen",
    TypeSetListHistoryTelephoneLineStatusSatiaScreen: "TypeSetListHistoryTelephoneLineStatusSatiaScreen",
    urlListHistoryTelephoneLineStatusSatiaScreen: BASE_URL_SN,
    urlSetListHistoryTelephoneLineStatusSatiaScreen: `/api/applyNotify`,
    SetListHistoryTelephoneLineStatusSatiaScreen_SERVICE_PENDING: 'SetListHistoryTelephoneLineStatusSatiaScreen_SERVICE_PENDING',
    SetListHistoryTelephoneLineStatusSatiaScreen_SERVICE_ERROR: 'SetListHistoryTelephoneLineStatusSatiaScreen_SERVICE_ERROR',
    SetListHistoryTelephoneLineStatusSatiaScreen_SERVICE_SUCCESS: 'SetListHistoryTelephoneLineStatusSatiaScreen_SERVICE_SUCCESS',
    ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_CHANGE_NOTIF: 'ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_CHANGE_NOTIF',
    ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_PENDING: 'ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_PENDING',
    ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_ERROR: 'ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_ERROR',
    ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_SUCCESS: 'ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_SUCCESS',
    ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_REFRESH: 'ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_REFRESH',
    ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_END: 'ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_END',
    ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_Empty: 'ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_Empty',
    ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_ADD_FIRST_DATA: 'ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_ADD_FIRST_DATA',
    ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_AddSubList: 'ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_AddSubList',
    ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_LIST_FILTER: 'ListHistoryTelephoneLineStatusSatiaScreen_SERVICE_LIST_FILTER',


//ListMessageOperatorSatiaScreen
    TypeGetListMessageOperatorSatiaScreen: "TypeGetListMessageOperatorSatiaScreen",
    TypeSetListMessageOperatorSatiaScreen: "TypeSetListMessageOperatorSatiaScreen",
    urlListMessageOperatorSatiaScreen: BASE_URL_SN,
    urlSetListMessageOperatorSatiaScreen: `/api/applyNotify`,
    SetListMessageOperatorSatiaScreen_SERVICE_PENDING: 'SetListMessageOperatorSatiaScreen_SERVICE_PENDING',
    SetListMessageOperatorSatiaScreen_SERVICE_ERROR: 'SetListMessageOperatorSatiaScreen_SERVICE_ERROR',
    SetListMessageOperatorSatiaScreen_SERVICE_SUCCESS: 'SetListMessageOperatorSatiaScreen_SERVICE_SUCCESS',
    ListMessageOperatorSatiaScreen_SERVICE_CHANGE_NOTIF: 'ListMessageOperatorSatiaScreen_SERVICE_CHANGE_NOTIF',
    ListMessageOperatorSatiaScreen_SERVICE_PENDING: 'ListMessageOperatorSatiaScreen_SERVICE_PENDING',
    ListMessageOperatorSatiaScreen_SERVICE_ERROR: 'ListMessageOperatorSatiaScreen_SERVICE_ERROR',
    ListMessageOperatorSatiaScreen_SERVICE_SUCCESS: 'ListMessageOperatorSatiaScreen_SERVICE_SUCCESS',
    ListMessageOperatorSatiaScreen_SERVICE_REFRESH: 'ListMessageOperatorSatiaScreen_SERVICE_REFRESH',
    ListMessageOperatorSatiaScreen_SERVICE_END: 'ListMessageOperatorSatiaScreen_SERVICE_END',
    ListMessageOperatorSatiaScreen_SERVICE_Empty: 'ListMessageOperatorSatiaScreen_SERVICE_Empty',
    ListMessageOperatorSatiaScreen_SERVICE_ADD_FIRST_DATA: 'ListMessageOperatorSatiaScreen_SERVICE_ADD_FIRST_DATA',
    ListMessageOperatorSatiaScreen_SERVICE_AddSubList: 'ListMessageOperatorSatiaScreen_SERVICE_AddSubList',
    ListMessageOperatorSatiaScreen_SERVICE_LIST_FILTER: 'ListMessageOperatorSatiaScreen_SERVICE_LIST_FILTER',


//ListQuestionAndAnswerSatiaScreen
    TypeGetListQuestionAndAnswerSatiaScreen: "TypeGetListQuestionAndAnswerSatiaScreen",
    TypeSetListQuestionAndAnswerSatiaScreen: "TypeSetListQuestionAndAnswerSatiaScreen",
    urlListQuestionAndAnswerSatiaScreen: BASE_URL_SN,
    urlSetListQuestionAndAnswerSatiaScreen: `/api/applyNotify`,
    SetListQuestionAndAnswerSatiaScreen_SERVICE_PENDING: 'SetListQuestionAndAnswerSatiaScreen_SERVICE_PENDING',
    SetListQuestionAndAnswerSatiaScreen_SERVICE_ERROR: 'SetListQuestionAndAnswerSatiaScreen_SERVICE_ERROR',
    SetListQuestionAndAnswerSatiaScreen_SERVICE_SUCCESS: 'SetListQuestionAndAnswerSatiaScreen_SERVICE_SUCCESS',
    ListQuestionAndAnswerSatiaScreen_SERVICE_CHANGE_NOTIF: 'ListQuestionAndAnswerSatiaScreen_SERVICE_CHANGE_NOTIF',
    ListQuestionAndAnswerSatiaScreen_SERVICE_PENDING: 'ListQuestionAndAnswerSatiaScreen_SERVICE_PENDING',
    ListQuestionAndAnswerSatiaScreen_SERVICE_ERROR: 'ListQuestionAndAnswerSatiaScreen_SERVICE_ERROR',
    ListQuestionAndAnswerSatiaScreen_SERVICE_SUCCESS: 'ListQuestionAndAnswerSatiaScreen_SERVICE_SUCCESS',
    ListQuestionAndAnswerSatiaScreen_SERVICE_REFRESH: 'ListQuestionAndAnswerSatiaScreen_SERVICE_REFRESH',
    ListQuestionAndAnswerSatiaScreen_SERVICE_END: 'ListQuestionAndAnswerSatiaScreen_SERVICE_END',
    ListQuestionAndAnswerSatiaScreen_SERVICE_Empty: 'ListQuestionAndAnswerSatiaScreen_SERVICE_Empty',
    ListQuestionAndAnswerSatiaScreen_SERVICE_ADD_FIRST_DATA: 'ListQuestionAndAnswerSatiaScreen_SERVICE_ADD_FIRST_DATA',
    ListQuestionAndAnswerSatiaScreen_SERVICE_AddSubList: 'ListQuestionAndAnswerSatiaScreen_SERVICE_AddSubList',
    ListQuestionAndAnswerSatiaScreen_SERVICE_LIST_FILTER: 'ListQuestionAndAnswerSatiaScreen_SERVICE_LIST_FILTER',


//ListMessageSatiaScreen
    TypeGetListMessageSatiaScreen: "TypeGetListMessageSatiaScreen",
    TypeSetListMessageSatiaScreen: "TypeSetListMessageSatiaScreen",
    urlListMessageSatiaScreen: BASE_URL_SN,
    urlSetListMessageSatiaScreen: `/api/applyNotify`,
    SetListMessageSatiaScreen_SERVICE_PENDING: 'SetListMessageSatiaScreen_SERVICE_PENDING',
    SetListMessageSatiaScreen_SERVICE_ERROR: 'SetListMessageSatiaScreen_SERVICE_ERROR',
    SetListMessageSatiaScreen_SERVICE_SUCCESS: 'SetListMessageSatiaScreen_SERVICE_SUCCESS',
    ListMessageSatiaScreen_SERVICE_CHANGE_NOTIF: 'ListMessageSatiaScreen_SERVICE_CHANGE_NOTIF',
    ListMessageSatiaScreen_SERVICE_PENDING: 'ListMessageSatiaScreen_SERVICE_PENDING',
    ListMessageSatiaScreen_SERVICE_ERROR: 'ListMessageSatiaScreen_SERVICE_ERROR',
    ListMessageSatiaScreen_SERVICE_SUCCESS: 'ListMessageSatiaScreen_SERVICE_SUCCESS',
    ListMessageSatiaScreen_SERVICE_REFRESH: 'ListMessageSatiaScreen_SERVICE_REFRESH',
    ListMessageSatiaScreen_SERVICE_END: 'ListMessageSatiaScreen_SERVICE_END',
    ListMessageSatiaScreen_SERVICE_Empty: 'ListMessageSatiaScreen_SERVICE_Empty',
    ListMessageSatiaScreen_SERVICE_ADD_FIRST_DATA: 'ListMessageSatiaScreen_SERVICE_ADD_FIRST_DATA',
    ListMessageSatiaScreen_SERVICE_AddSubList: 'ListMessageSatiaScreen_SERVICE_AddSubList',
    ListMessageSatiaScreen_SERVICE_LIST_FILTER: 'ListMessageSatiaScreen_SERVICE_LIST_FILTER',


//ListMicroConsumptionSatiaScreen
    TypeGetListMicroConsumptionSatiaScreen: "TypeGetListMicroConsumptionSatiaScreen",
    TypeSetListMicroConsumptionSatiaScreen: "TypeSetListMicroConsumptionSatiaScreen",
    urlListMicroConsumptionSatiaScreen: BASE_URL_SN,
    urlSetListMicroConsumptionSatiaScreen: `/api/applyNotify`,
    SetListMicroConsumptionSatiaScreen_SERVICE_PENDING: 'SetListMicroConsumptionSatiaScreen_SERVICE_PENDING',
    SetListMicroConsumptionSatiaScreen_SERVICE_ERROR: 'SetListMicroConsumptionSatiaScreen_SERVICE_ERROR',
    SetListMicroConsumptionSatiaScreen_SERVICE_SUCCESS: 'SetListMicroConsumptionSatiaScreen_SERVICE_SUCCESS',
    ListMicroConsumptionSatiaScreen_SERVICE_CHANGE_NOTIF: 'ListMicroConsumptionSatiaScreen_SERVICE_CHANGE_NOTIF',
    ListMicroConsumptionSatiaScreen_SERVICE_PENDING: 'ListMicroConsumptionSatiaScreen_SERVICE_PENDING',
    ListMicroConsumptionSatiaScreen_SERVICE_ERROR: 'ListMicroConsumptionSatiaScreen_SERVICE_ERROR',
    ListMicroConsumptionSatiaScreen_SERVICE_SUCCESS: 'ListMicroConsumptionSatiaScreen_SERVICE_SUCCESS',
    ListMicroConsumptionSatiaScreen_SERVICE_REFRESH: 'ListMicroConsumptionSatiaScreen_SERVICE_REFRESH',
    ListMicroConsumptionSatiaScreen_SERVICE_END: 'ListMicroConsumptionSatiaScreen_SERVICE_END',
    ListMicroConsumptionSatiaScreen_SERVICE_Empty: 'ListMicroConsumptionSatiaScreen_SERVICE_Empty',
    ListMicroConsumptionSatiaScreen_SERVICE_ADD_FIRST_DATA: 'ListMicroConsumptionSatiaScreen_SERVICE_ADD_FIRST_DATA',
    ListMicroConsumptionSatiaScreen_SERVICE_AddSubList: 'ListMicroConsumptionSatiaScreen_SERVICE_AddSubList',
    ListMicroConsumptionSatiaScreen_SERVICE_LIST_FILTER: 'ListMicroConsumptionSatiaScreen_SERVICE_LIST_FILTER',
    ListMicroConsumptionSatiaScreen_SERVICE_CREDITS: 'ListMicroConsumptionSatiaScreen_SERVICE_CREDITS',
    ListMicroConsumptionSatiaScreen_SERVICE_RESPONSE: 'ListMicroConsumptionSatiaScreen_SERVICE_RESPONSE',


    _HEIGHT: SCREEN_HEIGHT,
    _WIDTH: SCREEN_WIDTH,

//125
    //_TypeApp: '125',
    _baseUrl125: _baseUrl125,

    //  _NameApp:'125',
    _Fire: 'Fire',

    //FireChabahar
    //_Fire: 'FireChabahar',
    // _NameApp: 'FireChabahar',
    // _NameMap: 'Chabahar',
    // _NameCity:'چابهار',
    // _Registration: 'FireChabahar',
    // _Contacts: 'FireChabahar',


    //FireArdabil
    //_Fire: 'FireArdabil',
    // _NameApp: 'FireArdabil',
    // _NameMap: 'Ardabil',
    // _NameCity:'اردبیل',
    // _Registration: 'FireArdabil',
    // _Contacts: 'FireArdabil',

    //FireDezfol
    //_Fire: 'FireDezfol',
    // _NameApp: 'FireDezfol',
    // _NameMap: 'Dezfol',
    // _NameCity:'دزفول',
    // _Registration: 'FireDezfol',
    // _Contacts: 'FireDezfol',


    //FireZarghan
    //_Fire: 'FireZarghan',
    // _NameApp: 'FireZarghan',
    // _NameMap: 'FireZarghan',
    // _NameCity:'زرقان',
    // _Registration: 'FireZarghan',
    // _Contacts: 'FireZarghan',


    //******************************************************//
    _TypeApp: '137',
    _Url137: BASE_URL_SATIA,

    //Satia
    // _NameApp: 'Satia',
    //_TypeApp: 'Satia',


    //SatiaOperattor
    //_TypeApp: 'Satia',
    //_NameApp: 'SatiaOperator',

    //SatiaHotspot
    //_TypeApp: 'Satia',
    //_NameApp: 'SatiaHotspot',

    // _NameApp: 'Arak',
    // _Registration: 'Registration',
    // _Contacts: 'Contacts',
    // _NameMap: 'Arak',
    // _NameCity: 'اراک',

    //Golpayegan
    // _NameApp: 'Golpayegan',
    //  _Registration: 'Registration',
    //  _Contacts: 'Contacts',
    //  _NameMap: 'Golpayegan',
    //  _NameCity: 'گلپایگان',

    //Boumehen
    // _NameApp: 'Boumehen',
    //  _Registration: 'Boumehen',
    //  _Contacts: 'Boumehen',
    //  _NameMap: 'Boumehen',
    //  _NameCity: 'بومهن',

    //Zarghan
    // _NameApp: 'Zarghan',
    //  _Registration: 'Zarghan',
    //  _Contacts: 'Zarghan',
    //  _NameMap: 'Zarghan',
    //  _NameCity: 'زرقان',

    //Lavasan
    // _NameApp: 'Lavasan',
    //  _Registration: 'Lavasan',
    //  _Contacts: 'Lavasan',
    //  _NameMap: 'Lavasan',
    //  _NameCity: 'لواسان',

    //Abadeh
    // _NameApp: 'Abadeh',
    //  _Registration: 'Abadeh',
    //  _Contacts: 'Abadeh',
    //  _NameMap: 'Abadeh',
    //  _NameCity: 'آباده',


    //Rafsanjan
    // _NameApp: 'Rafsanjan',
    //  _Registration: 'Registration',
    //  _Contacts: 'Contacts',
    //  _NameMap: 'Rafsanjan',
    //  _NameCity: 'رفسنجان',

//Police
//     _NameApp: 'Police',
//     _Registration: 'Police',
//     _Contacts: 'Police',
//     _NameMap: 'Arak',
//     _NameCity: 'اراک',

//Demo_php
//     _NameApp: 'Demo_php',
//     _Registration: 'Registration',
//     _Contacts: 'Contacts',
//     _NameMap: 'Arak',
//     _NameCity: 'اراک',


    //shahrban
    // _NameApp: 'Ahvaz',
    // _Registration: 'Ahvaz',
    // _Contacts: 'Ahvaz',
    // _NameMap: 'Ahvaz',
    // _NameCity:'اهواز',

//Marvdasht
//     _NameApp: 'Marvdasht',
//     _Registration: 'Marv',
//     _Contacts: 'Marv',
//     _NameMap: 'Marvdasht',
//     _NameCity: 'مرودشت',


//Kerman
//     _NameApp: 'Kerman',
//     _Registration: 'Registration',
//     _Contacts: 'Contacts',
//     _NameMap: 'Kerman',
//     _NameCity: 'کرمان',


    //shahrban﴿
    //_NameApp: 'Ahvaz',
    //_Registration: 'Ahvaz',
    //_Contacts: 'Ahvaz',
    //_NameMap: 'Ahvaz',
    //_NameCity:'اهواز',


    //Jahrom
    //_NameApp: 'Jahrom',
    //_Registration: 'Jahrom',
    //_Contacts: 'Jahrom',
    //_NameMap: 'Jahrom',
    //_NameCity:'جهرم',


    //Ilam
    //_NameApp: 'Ilam',
    //_Registration: 'Ilam',
    //_Contacts: 'Ilam',
    //_NameMap: 'Ilam',
    //_NameCity:'ایلام',

    //MahmoodAbad
    // _NameApp: 'MahmoodAbad',
    // _Registration: 'MahmoodAbad',
    // _Contacts: 'MahmoodAbad',
    // _NameMap: 'MahmoodAbad',
    // _NameCity:'محمودآباد',

    //MahalemaArak
    // _NameApp: 'MahalemaArak',
    // _Registration: 'MahalemaArak',
    // _Contacts: 'MahalemaArak',
    // _NameMap: 'MahalemaArak',
    // _NameCity:'اراک',


    //Borazjan
    // _NameApp: 'Borazjan',
    // _Registration: 'Borazjan',
    // _Contacts: 'Borazjan',
    // _NameMap: 'Borazjan',
    // _NameCity:'برازجان',

    //Roudan
    // _NameApp: 'Roudan',
    // _Registration: 'Roudan',
    // _Contacts: 'Roudan',
    // _NameMap: 'Roudan',
    // _NameCity:'رودان',

    //Maraghe
    // _NameApp: 'Maraghe',
    // _Registration: 'Maraghe',
    // _Contacts: 'Maraghe',
    // _NameMap: 'Maraghe',
    // _NameCity:'مراغه',
    //_NameCity: 'آذربایجان شرقی',

    //Khorramshahr
    // _NameApp: 'Khorramshahr',
    // _Registration: 'Khorramshahr',
    // _Contacts: 'Khorramshahr',
    // _NameMap: 'Khorramshahr',
    // _NameCity:'خرمشهر',

    //Bushehr
    // _NameApp: 'Bushehr',
    // _Registration: 'Bushehr',
    // _Contacts: 'Bushehr',
    // _NameMap: 'Bushehr',
    // _NameCity:'بوشهر',

    //Gerash
    // _NameApp: 'Gerash',
    // _Registration: 'Gerash',
    // _Contacts: 'Gerash',
    // _NameMap: 'Gerash',
    // _NameCity:'گراش',

    //Behbahan
    // _NameApp: 'Behbahan',
    // _Registration: 'Behbahan',
    // _Contacts: 'Behbahan',
    // _NameMap: 'Behbahan',
    // _NameCity:'بهبهان',

    //Cloud
    _NameApp: 'Cloud',
    _Registration: 'Cloud',
    _Contacts: 'Cloud',
    _NameMap: 'Cloud',
    _NameCity:'ایران',


    //Shahrman
    // _NameApp: 'Shahrman',
    // _Registration: 'Shahrman',
    // _Contacts: 'Shahrman',
    // _NameMap: 'Shahrman',
    // _NameCity: 'اراک',

    _BakhshMarkazi: 'بخش مرکزی,',
    _Area: 'منطقه',

    _GetSubjects: 'GetSubjects',
    _GetInfo: 'GetInfo',
    _GetTickets: 'GetTickets',
    _baseUrlSainaShahrdar: BASE_URLS + '/modules/Mobile/api.php',
    _baseUrlSainaShahrvand: BASE_URLS + '/modules/CustomerPortal/api.php',

    _sendCode: "SendCode",
    _sendCodeMode: "SendCode",
    _RegisterMode: "Register",
    mode: "Login",
    _verifyCode: "Registration",
    _verifyCodeMode: "VerifyCode",
    _AramestanSearch: "AramestanSearch",

    //Arak and  all
    //  _Shahrdar: "shahrdar",

    //Demo
    // _Shahrdar: "shahrdar_Demo",

    //Demo_php
    // _Shahrdar: "shahrdar",

    //Ahvaz
//    _Shahrdar: "shahrdar_Ahvaz",

    //MahmoodAbad
//    _Shahrdar: "shahrdar_MahmoodAbad",

    //MahalemaArak
//    _Shahrdar: "Mahalema_Arak",


//Borazjan
//    _Shahrdar: "shahrdar_Borazjan",

//Roudan
//    _Shahrdar: "shahrdar_Roudan",


//Maraghe
//    _Shahrdar: "shahrdar_Maraghe",

//Khorramshahr
//    _Shahrdar: "shahrdar_Khorramshahr",

//Bushehr
//    _Shahrdar: "shahrdar_Bushehr",

//Gerash
//    _Shahrdar: "shahrdar_Gerash",

//Behbahan
//    _Shahrdar: "shahrdar_Behbahan",

//Boumehen
//    _Shahrdar: "shahrdar_Boumehen",

//Zarghan
//    _Shahrdar: "shahrdar_Zarghan",

//Lavasan
//    _Shahrdar: "shahrdar_Lavasan",

//Abadeh
//    _Shahrdar: "shahrdar_Abadeh",

//Cloud
   _Shahrdar: "shahrdar_Cloud",

//Shahrman
//     _Shahrdar: "shahrdar_Shahrman",

//Marvdasht
//    _Shahrdar: "shahrdar_Marv",

//Ilam
//    _Shahrdar: "shahrdar_Ilam",

    _login: 'login',
    _GetMenuShahrdar: 'GetMenuShahrdar',
    _GetCalendar: 'GetCalendar',
    _GetDashboard: 'GetDashboard',
    _GetCsStatus: "GetCsStatus",
    _SaveComments: "SaveComments",


    _TypeLogin: "_TypeLogin",
    _UrlWebService125: "_UrlWebService125",
    _DeviceType: "_DeviceType",
    _USER: "_USER",
    _INTRO: "_INTRO",


    optional: (Platform.OS === 'ios' ?
        {
            enableRotationGesture: true,
            compressImageQuality: .5
        }
        :
        {
            compressImageMaxWidth: 1000,
            compressImageMaxHeight: 1000,
            enableRotationGesture: true,
            cropping: true,
        }),

    optionalMultiple: (Platform.OS === 'ios' ?
        {
            enableRotationGesture: true,
            compressImageQuality: .5,
            multiple: true
        }
        :
        {
            compressImageMaxWidth: 1000,
            compressImageMaxHeight: 1000,
            enableRotationGesture: true,
            multiple: true
        }),


    //satiaisp
    SPLASH_SATIA_SERVICE_REFRESH: "SPLASH_SATIA_SERVICE_REFRESH",
    SPLASH_SATIA_SERVICE_PENDING: "SPLASH_SATIA_SERVICE_PENDING",
    SPLASH_SATIA_SERVICE_ERROR: "SPLASH_SATIA_SERVICE_ERROR",
    SPLASH_SATIA_SERVICE_SUCCESS: "SPLASH_SATIA_SERVICE_SUCCESS",

    SPLASH_SATIA_SERVICE_PENDING_Satia: "SPLASH_SATIA_SERVICE_PENDING_Satia",
    SPLASH_SATIA_SERVICE_ERROR_Satia: "SPLASH_SATIA_SERVICE_ERROR_Satia",
    SPLASH_SATIA_SERVICE_SUCCESS_Satia: "SPLASH_SATIA_SERVICE_SUCCESS_Satia",
    SPLASH_SATIA_SERVICE_PENDING_CITY: "SPLASH_SATIA_SERVICE_PENDING_CITY",
    SPLASH_SATIA_SERVICE_ERROR_CITY: "SPLASH_SATIA_SERVICE_ERROR_CITY",

    /*    cardStyle: Platform.select({
            ios: () =>
                StyleSheet.create({
                    container: {
                        shadowRadius: moderateScale(3),
                        shadowOpacity: .5,
                        shadowOffset: {width: 0, height: moderateScale(3)},
                        borderRadius: moderateScale(5),
                        backgroundColor: '#ffffff',
                        width: Dimensions.get('window').width - moderateScale(40),
                    }
                }),
            android: () =>
                StyleSheet.create({
                    container: {
                        elevation: 2,
                        borderRadius: moderateScale(3),
                        backgroundColor: '#ffffff',
                        width: Dimensions.get('window').width - moderateScale(40),
                        borderBottomWidth: 0.2,
                        borderTopWidth: 0.2,
                        borderRightWidth: 0.2,
                        borderColor: '#000'

                    }
                })
        })(),*/


    _TIMEOUT: 60 * 1 * 1000,
    _TIMEOUT_FILE: 60 * 7 * 1000,
    Latitude: 34.08777640387088,
    Longitude: 49.66736778005486,
    ANNOTATION_SIZE: 45,
    SIZE_FILE: 8,//mb
    ORGINAL_SIZE_FILE: 59,//mb
    IS_ANDROID: (Platform.OS !== 'ios'),
    IS_IOS: (Platform.OS === 'ios'),

    SPEED_ANIMATION: SCREEN_HEIGHT,

    HEIGHT: SCREEN_HEIGHT,
    HEIGHT_IMAGE: 6.5,
    WIDTH: SCREEN_WIDTH,

    // regularFontName:Platform.OS==='web'?"IRANSansMobile-fa": "IRANSansMobile(FaNum)",
    regularFontName: Platform.OS === 'web' ? "IRANSansMobile-fa" : "IRANSansMobile(FaNum)",
    boldFontName: Platform.OS === 'web' ? "IRANSansMobile-fa" : "IRANSansMobile(FaNum)_Bold",
    lightFontName: Platform.OS === 'web' ? "IRANSansMobile-fa" : "IRANSansMobile(FaNum)_Light",


    /*
        regularFontName: Platform.OS === 'web' ? "BYekan" : "BYekan",
        boldFontName: Platform.OS === 'web' ? "BYekan" : "BYekan",
        lightFontName: Platform.OS === 'web' ? "BYekan" : "BYekan",
    */


    // regularFontName: Platform.OS === 'web' ? "BTitrBold" : "BTitrBold",
    // boldFontName: Platform.OS === 'web' ? "BTitrBold" : "BTitrBold",
    // lightFontName: Platform.OS === 'web' ? "BTitrBold" : "BTitrBold",

    /*regularFontName :"IRANSansMobile(FaNum)";
    boldFontName :"IRANSansMobile(FaNum)";
    lightFontName :"IRANSansMobile(FaNum)";*/
    materialPlaceHolder: "هویج خیار شور بادام هندی کره بادام زمینی گوجه فرنگی بادمجون ترش بادمجون شیرین قااارچ",
    lorem2: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. ",
    lorem1: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.",


    LevelonEndReachedThreshold: 2 / 1.6,

    LinkAndroid: "https://cafebazaar.ir/app/com.hoonam.pizzasorkh/?l=fa",
    LinkIos: "https://sibapp.com/applications/amomilad",


    _GET: "GET",
    _POST: "POST",
    // NameApp: i18n.t('appName'),
    NameApp: "arak",


    UrlPortal: "http://arak.ir/",


    baseUrlWP: baseUrlWP_OR + "/index.php/wp-json/satia/v2/",
    baseUrlImageWP: baseUrlWP_OR,
//const _baseUrlSaina :"http://portal.arak.ir/modules/CustomerPortal/api.php",


//sharban
//UrlPortal :"http://ahvaz.ir/",
//NameApp :"شهربان",
//baseUrlWP :"http://ahvaz.iran137.com/index.php/wp-json/satia/v2/",
//baseUrlImageWP :"http://app.satiaisp.com/",
//baseUrlImageWP :"http://ahvaz.iran137.com/",
//const _baseUrlSaina :"http://185.113.56.50/modules/CustomerPortal/api.php",


    baseUrlImageSN: _baseUrlSaina,
    _baseUrlSatia: BASE_URL_SATIA,
    _baseUrlImageAssets: (URL_PWA_IMAGE ? URL_PWA_IMAGE : URL_PWA) + "/assets/images/",
    _baseUrlImages: URL_PWA + "/images/",

    UrlHoonam: "http://www.google.com",

    id_category: 0,
    id_SubCategory: 0,
    id_ChidSubCategory: 0,


    _ACCOUNT: "Account",
    IDCITY: "_IDCITY",
    NAMECITY: "_NAMECITY",
    IDSTATE: "_IDSTATE",
    NAMESTATE: "_NAMESTATE",
    TOKEN: "_TOKEN",
    NATIONALCOD: "_NATIONALCOD",
    NAME: "_NAME",
    MOBILE: "_MOBILE",
    Rtl: "_Rtl",
    LANG: "_LANG",
    ImageSplash: "_ImageSplash",
    _ImageBackground: "_ImageBackground",

    // HeightStatusBar: moderateScale(20),
    HeightStatusBar: 20,
    VersionImage: "?1",

    SideMenu: "_SideMenu",
    SideMenuClose: "_SideMenuClose",
    SideMenuToggle: "_SideMenuToggle",


//LoginEnterPhoneScreen
    TypegetDataLoginEnterPhoneScreen: "TypegetDataLoginEnterPhoneScreen",
    urlGetLoginEnterPhoneScreen: _baseUrlSaina,


//LoginEnterPhoneCodeScreen
    TypegetDataLoginEnterPhoneCodeScreen: "TypegetDataLoginEnterPhoneCodeScreen",

    urlGetLoginEnterPhoneCodeScreen: _baseUrlSaina,

//LoginScreen
    TypegetDataLoginScreen: "TypegetDataLoginScreen",
    urlGetLoginScreen: `/api/auth/login`,

//EnterCodeScreen
    TypegetDataEnterCodeScreen: "TypegetDataEnterCodeScreen",

//LoginEnterPhoneSatiaScreen
    TypegetDataLoginEnterPhoneSatiaScreen: "TypegetDataLoginEnterPhoneSatiaScreen",
    urlGetLoginEnterPhoneSatiaScreen: _baseUrlSaina,


//LoginSatiaScreen
    TypegetDataLoginSatiaScreen: "TypegetDataLoginSatiaScreen",
    urlGetLoginSatiaScreen: `/api/auth/login`,

//EnterCodeSatiaScreen
    TypegetDataEnterCodeSatiaScreen: "TypegetDataEnterCodeSatiaScreen",

    //ChangeInformationScreen
    urlGetInformationSatiaScreen: _baseUrlSaina,
    urlGetChangeInformationScreen: _baseUrlSaina,
    TypegetDataChangeInformationScreen: "TypegetDataChangeInformationScreen",
    TypegetDataInformationScreen: "TypegetDataInformationScreen",
    urlSetChangeInformationScreen: _baseUrlSaina,
    TypeSetDataChangeInformationScreen: "TypeSetDataChangeInformationScreen",
    TypeSetDataInformationScreen: "TypeSetDataInformationScreen",

    //ChangeInformationSatiaScreen
    urlGetChangeInformationSatiaScreen: BASE_URL_SATIA,
    TypegetDataChangeInformationSatiaScreen: "TypegetDataChangeInformationSatiaScreen",
    TypegetDataInformationSatiaScreen: "TypegetDataInformationSatiaScreen",
    urlSetChangeInformationSatiaScreen: BASE_URL_SATIA,
    TypeSetDataChangeInformationSatiaScreen: "TypeSetDataChangeInformationSatiaScreen",
    TypeSetDataInformationSatiaScreen: "TypeSetDataInformationScreen",


    urlGetCompetitionScreen: _baseUrlSaina,
    TypegetDataCompetitionScreen: "TypegetDataCompetitionScreen",
//TypegetDataInformationScreen : "TypegetDataInformationScreen",
    urlSetCompetitionScreen: _baseUrlSaina,
    TypeSetDataCompetitionScreen: "TypeSetDataCompetitionScreen",

    urlGetInformationScreen: _baseUrlSaina,
    urlGetEnterCodeScreen: _baseUrlSaina,
    urlGetCheckToken: `/api/application/api/check`,

// splash
    urlGetAllData: `submenu`,
    urlGetAllDataSaina: _baseUrlSaina,
    TypeGetAllDataSaina: "TypeGetAllDataSaina",
    urlGetAllDataSatia: BASE_URL_SATIA,
    urlGetSatia: BASE_URL_SATIA,
    TypeGetAllDataSatia: "TypeGetAllDataSatia",

    urlGetAllData125: _baseUrl125,
    TypeGetAllData: "TypeGetAllData",
    TypeGetAllData125: "TypeGetAllData125",
    TypeGetAllDataShardar: "TypeGetAllDataShardar",
    TypeGetCityData: "TypeGetCityData",

//SubmitRequest
    TypeGetSubmitRequest: "TypeGetSubmitRequest",

    urlGetSubmitRequest: _baseUrlSaina,
    urlGetSubmitManInjam: _baseUrlSaina,

// DetialRestaurant
    urlGetAllDataDetialRestaurant: `/api/application/api/restaurant/show`,
    TypeGetAllDataDetialRestaurant: "TypeGetAllDataDetialRestaurant",


//Order ListScreen
    TypeGetDataOrderListScreen: "TypeGetDataOrderListScreen",
    urlGetOrderListScreen: `/api/application/api/user/orders`,


//CommentScreen
    TypegetDataCommentScreen: "TypegetDataCommentScreen",
    TypeSetDataCommentScreen: "TypeSetDataCommentScreen",
    urlGetCommentScreen: `/api/application/api/comments`,
    urlSetCommentScreen: `/api/application/api/user/store/comment`,

//FoodDetailsScreen
    TypegetDataFoodDetailsScreen: "TypegetDataFoodDetailsScreen",
    TypeSetDataFoodDetailsScreen: "TypeSetDataFoodDetailsScreen",
    urlGetFoodDetailsScreen: `/api/application/api/single/food?`,
    urlSetFoodDetailsScreen: `/api/application/api/user/store/single?`,

//increase credit
    typeSetIncreaseCredit: "typeSetIncreaseCredit",
    urlSetIncreaseCredit: `/api/application/api/payment/increase/wallet`,

//PayScreen
    TypeSetDataPayScreen: `TypeSetDataPayScreen`,
    urlSetPayScreen: `payments/payment?`,

//PaySatiaScreen
    TypeSetDataPaySatiaScreen: `TypeSetDataPaySatiaScreen`,
    urlSetPaySatiaScreen: `payments/payment?`,

    urlSetCompotitionScreen: `/api/application/api/competition/store?`,


//SEARCH
    TypegetDataSEARCH: "TypegetDataSEARCH",
    urlGetSearchScreen: `/api/application/api/restaurant/search`,

//DetialRestaurant
    TypegetDataDetialRestaurant: "TypegetDataDetialRestaurant",
    urlGetDataDetialRestaurantScreen: `/api/application/api/restaurant/show`,


//DetialRestaurant
    TypegetPannelScreen: "TypegetPannelScreen",
    urlGetDataPannelScreen: `/api/application/api/restaurant/show`,

//TypeMyApplyScreen
    TypeGetMyApplyScreen: "TypeGetMyApplyScreen",
    TypeSetMyApplyScreen: "TypeSetMyApplyScreen",
    urlMyApplyScreen: `/api/myApplies`,
    urlSetMyApplyScreen: `/api/applyNotify`,

//PannelDetailStoreScreen
    urlPannelDetailStoreScreen: `/api/user/product/get?`,
    urlSetPannelDetailStoreScreen: `/api/user/product/set?`,
    TypePannelDetailStoreScreen: "_TypePannelDetailStoreScreent",
    TypeSetPannelDetailStoreScreen: "_TypeSetPannelDetailStoreScreen",


//Messages
    TypeGetMessagesBuy: "TypeGetMessagesBuy",
    TypeGetMessagesSell: "TypeGetMessagesSell",
    TypeMessagesAll: "TypeMessagesAll",
    urlMessagesAll: "/api/showNotifyList",


//MenuDrawer
    TypeGetMenuDrawer: "TypeGetMenuDrawer",
    TypeSetMenuDrawer: "TypeSetMenuDrawer",
    urlMenuDrawer: `/api/notify`,


//FinalRequest
    TypeGetFinalRequestScreen: "TypeGetFinalRequestScreen",
    TypeSetFinalRequestScreen: "TypeSetFinalRequestScreen",
    urlFinalRequestScreen: `/api/storeProperty`,


//ChangPssScreen
    TypeGetChangPssScreen: "TypeGetChangPssScreen",
    TypeSetChangPssScreen: "TypeSetChangPssScreen",
    urlChangPssScreen: _baseUrlSaina,


//ChangPssSatiaScreen
    TypeGetChangPssSatiaScreen: "TypeGetChangPssSatiaScreen",
    TypeSetChangPssSatiaScreen: "TypeSetChangPssSatiaScreen",
    urlChangPssSatiaScreen: BASE_URL_SATIA + "user/changePassProfile",

    _baseUrlSaina: _baseUrlSaina
}
